var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwissMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 462.62 245.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.25;}.cls-2{fill:#1c2c58;}.cls-3{fill:#c22026;}.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "swiss map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,4a2,2,0,1,0-2-2A2,2,0,0,0,243.38,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,4a2,2,0,1,0-2-2A2,2,0,0,0,251.43,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,4a2,2,0,1,0-2-2A2,2,0,0,0,259.47,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,4a2,2,0,1,0-2-2A2,2,0,0,0,267.52,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,12a2,2,0,1,0-2-2A2,2,0,0,0,243.38,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,12a2,2,0,1,0-2-2A2,2,0,0,0,251.43,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,12a2,2,0,1,0-2-2A2,2,0,0,0,259.47,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,12a2,2,0,1,0-2-2A2,2,0,0,0,267.52,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,20.08a2,2,0,1,0-2-2A2,2,0,0,0,243.38,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,20.08a2,2,0,1,0-2-2A2,2,0,0,0,251.43,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,20.08a2,2,0,1,0-2-2A2,2,0,0,0,259.47,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,20.08a2,2,0,1,0-2-2A2,2,0,0,0,267.52,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,20.08a2,2,0,1,0-2-2A2,2,0,0,0,275.57,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,20.08a2,2,0,1,0-2-2A2,2,0,0,0,291.66,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,20.08a2,2,0,1,0-2-2A2,2,0,0,0,299.7,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,20.08a2,2,0,1,0-2-2A2,2,0,0,0,307.75,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,20.08a2,2,0,1,0-2-2A2,2,0,0,0,315.8,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,28.12a2,2,0,1,0-2-2A2,2,0,0,0,98.55,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,28.12a2,2,0,1,0-2-2A2,2,0,0,0,106.59,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,28.12a2,2,0,1,0-2-2A2,2,0,0,0,114.64,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,28.12a2,2,0,1,0-2-2A2,2,0,0,0,122.69,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,28.12a2,2,0,1,0-2-2A2,2,0,0,0,211.2,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,28.12a2,2,0,1,0-2-2A2,2,0,0,0,219.24,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,28.12a2,2,0,1,0-2-2A2,2,0,0,0,227.29,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,28.12a2,2,0,1,0-2-2A2,2,0,0,0,243.38,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,28.12a2,2,0,1,0-2-2A2,2,0,0,0,251.43,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,28.12a2,2,0,1,0-2-2A2,2,0,0,0,259.47,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,28.12a2,2,0,1,0-2-2A2,2,0,0,0,267.52,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,28.12a2,2,0,1,0-2-2A2,2,0,0,0,275.57,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,28.12a2,2,0,1,0-2-2A2,2,0,0,0,283.61,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,28.12a2,2,0,1,0-2-2A2,2,0,0,0,291.66,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,28.12a2,2,0,1,0-2-2A2,2,0,0,0,299.7,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,28.12a2,2,0,1,0-2-2A2,2,0,0,0,307.75,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,28.12a2,2,0,1,0-2-2A2,2,0,0,0,315.8,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,28.12a2,2,0,1,0-2-2A2,2,0,0,0,323.84,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,36.17a2,2,0,1,0-2-2A2,2,0,0,0,90.5,36.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.55,
    cy: 34.18,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,36.17a2,2,0,1,0-2-2A2,2,0,0,0,106.59,36.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 34.18,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 34.18,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,36.17a2,2,0,1,0-2-2A2,2,0,0,0,130.73,36.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 34.18,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,36.17a2,2,0,1,0-2-2A2,2,0,0,0,171,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,36.17a2,2,0,1,0-2-2A2,2,0,0,0,179,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,36.17a2,2,0,1,0-2-2A2,2,0,0,0,187.06,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,36.17a2,2,0,1,0-2-2A2,2,0,0,0,195.1,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,36.17a2,2,0,1,0-2-2A2,2,0,0,0,203.15,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,36.17a2,2,0,1,0-2-2A2,2,0,0,0,211.2,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,36.17a2,2,0,1,0-2-2A2,2,0,0,0,219.24,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,36.17a2,2,0,1,0-2-2A2,2,0,0,0,227.29,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,36.17a2,2,0,1,0-2-2A2,2,0,0,0,235.33,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,36.17a2,2,0,1,0-2-2A2,2,0,0,0,243.38,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,36.17a2,2,0,1,0-2-2A2,2,0,0,0,251.43,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,36.17a2,2,0,1,0-2-2A2,2,0,0,0,259.47,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,36.17a2,2,0,1,0-2-2A2,2,0,0,0,267.52,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,36.17a2,2,0,1,0-2-2A2,2,0,0,0,275.57,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,36.17a2,2,0,1,0-2-2A2,2,0,0,0,283.61,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,36.17a2,2,0,1,0-2-2A2,2,0,0,0,291.66,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,36.17a2,2,0,1,0-2-2A2,2,0,0,0,299.7,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,36.17a2,2,0,1,0-2-2A2,2,0,0,0,307.75,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,36.17a2,2,0,1,0-2-2A2,2,0,0,0,315.8,36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,36.17a2,2,0,1,0-2-2A2,2,0,0,0,323.84,36.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.89,
    cy: 34.18,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 339.94,
    cy: 34.18,
    r: 1.99,
    transform: "translate(304.8 374.02) rotate(-89.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,44.21a2,2,0,1,0-2-2A2,2,0,0,0,90.5,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,44.21a2,2,0,1,0-2-2A2,2,0,0,0,98.55,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,44.21a2,2,0,1,0-2-2A2,2,0,0,0,106.59,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,44.21a2,2,0,1,0-2-2A2,2,0,0,0,114.64,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,44.21a2,2,0,1,0-2-2A2,2,0,0,0,122.69,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,44.21a2,2,0,1,0-2-2A2,2,0,0,0,130.73,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,44.21a2,2,0,1,0-2-2A2,2,0,0,0,138.78,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,44.21a2,2,0,1,0-2-2A2,2,0,0,0,146.83,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,44.21a2,2,0,1,0-2-2A2,2,0,0,0,154.87,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,44.21a2,2,0,1,0-2-2A2,2,0,0,0,162.92,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,44.21a2,2,0,1,0-2-2A2,2,0,0,0,171,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,44.21a2,2,0,1,0-2-2A2,2,0,0,0,179,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,44.21a2,2,0,1,0-2-2A2,2,0,0,0,187.06,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,44.21a2,2,0,1,0-2-2A2,2,0,0,0,195.1,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,44.21a2,2,0,1,0-2-2A2,2,0,0,0,203.15,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,44.21a2,2,0,1,0-2-2A2,2,0,0,0,211.2,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,44.21a2,2,0,1,0-2-2A2,2,0,0,0,219.24,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,44.21a2,2,0,1,0-2-2A2,2,0,0,0,227.29,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,44.21a2,2,0,1,0-2-2A2,2,0,0,0,235.33,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,44.21a2,2,0,1,0-2-2A2,2,0,0,0,243.38,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,44.21a2,2,0,1,0-2-2A2,2,0,0,0,251.43,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,44.21a2,2,0,1,0-2-2A2,2,0,0,0,259.47,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,44.21a2,2,0,1,0-2-2A2,2,0,0,0,267.52,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,44.21a2,2,0,1,0-2-2A2,2,0,0,0,275.57,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,44.21a2,2,0,1,0-2-2A2,2,0,0,0,283.61,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,44.21a2,2,0,1,0-2-2A2,2,0,0,0,291.66,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,44.21a2,2,0,1,0-2-2A2,2,0,0,0,299.7,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,44.21a2,2,0,1,0-2-2A2,2,0,0,0,307.75,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,44.21a2,2,0,1,0-2-2A2,2,0,0,0,315.8,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,44.21a2,2,0,1,0-2-2A2,2,0,0,0,323.84,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,44.21a2,2,0,1,0-2-2A2,2,0,0,0,331.89,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,44.21a2,2,0,1,0-2-2A2,2,0,0,0,339.94,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,44.21a2,2,0,1,0-2-2A2,2,0,0,0,348,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,44.21a2,2,0,1,0-2-2A2,2,0,0,0,356,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,52.26a2,2,0,1,0-2-2A2,2,0,0,0,98.55,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,52.26a2,2,0,1,0-2-2A2,2,0,0,0,106.59,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,52.26a2,2,0,1,0-2-2A2,2,0,0,0,114.64,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,52.26a2,2,0,1,0-2-2A2,2,0,0,0,122.69,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,52.26a2,2,0,1,0-2-2A2,2,0,0,0,130.73,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,52.26a2,2,0,1,0-2-2A2,2,0,0,0,138.78,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,52.26a2,2,0,1,0-2-2A2,2,0,0,0,146.83,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,52.26a2,2,0,1,0-2-2A2,2,0,0,0,154.87,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,52.26a2,2,0,1,0-2-2A2,2,0,0,0,162.92,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,52.26a2,2,0,1,0-2-2A2,2,0,0,0,171,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,52.26a2,2,0,1,0-2-2A2,2,0,0,0,179,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,52.26a2,2,0,1,0-2-2A2,2,0,0,0,187.06,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,52.26a2,2,0,1,0-2-2A2,2,0,0,0,195.1,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,52.26a2,2,0,1,0-2-2A2,2,0,0,0,203.15,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,52.26a2,2,0,1,0-2-2A2,2,0,0,0,211.2,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,52.26a2,2,0,1,0-2-2A2,2,0,0,0,219.24,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,52.26a2,2,0,1,0-2-2A2,2,0,0,0,227.29,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,52.26a2,2,0,1,0-2-2A2,2,0,0,0,235.33,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,52.26a2,2,0,1,0-2-2A2,2,0,0,0,243.38,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,52.26a2,2,0,1,0-2-2A2,2,0,0,0,251.43,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,52.26a2,2,0,1,0-2-2A2,2,0,0,0,259.47,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,52.26a2,2,0,1,0-2-2A2,2,0,0,0,267.52,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,52.26a2,2,0,1,0-2-2A2,2,0,0,0,275.57,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,52.26a2,2,0,1,0-2-2A2,2,0,0,0,283.61,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,52.26a2,2,0,1,0-2-2A2,2,0,0,0,291.66,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,52.26a2,2,0,1,0-2-2A2,2,0,0,0,299.7,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,52.26a2,2,0,1,0-2-2A2,2,0,0,0,307.75,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,52.26a2,2,0,1,0-2-2A2,2,0,0,0,315.8,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,52.26a2,2,0,1,0-2-2A2,2,0,0,0,323.84,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,52.26a2,2,0,1,0-2-2A2,2,0,0,0,331.89,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,52.26a2,2,0,1,0-2-2A2,2,0,0,0,339.94,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,52.26a2,2,0,1,0-2-2A2,2,0,0,0,348,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,52.26a2,2,0,1,0-2-2A2,2,0,0,0,356,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,52.26a2,2,0,1,0-2-2A2,2,0,0,0,364.08,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,60.31a2,2,0,1,0-2-2A2,2,0,0,0,106.59,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,60.31a2,2,0,1,0-2-2A2,2,0,0,0,114.64,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,60.31a2,2,0,1,0-2-2A2,2,0,0,0,122.69,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,60.31a2,2,0,1,0-2-2A2,2,0,0,0,130.73,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,60.31a2,2,0,1,0-2-2A2,2,0,0,0,138.78,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,60.31a2,2,0,1,0-2-2A2,2,0,0,0,146.83,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,60.31a2,2,0,1,0-2-2A2,2,0,0,0,154.87,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,60.31a2,2,0,1,0-2-2A2,2,0,0,0,162.92,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,60.31a2,2,0,1,0-2-2A2,2,0,0,0,171,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,60.31a2,2,0,1,0-2-2A2,2,0,0,0,179,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,60.31a2,2,0,1,0-2-2A2,2,0,0,0,187.06,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,60.31a2,2,0,1,0-2-2A2,2,0,0,0,195.1,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,60.31a2,2,0,1,0-2-2A2,2,0,0,0,203.15,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,60.31a2,2,0,1,0-2-2A2,2,0,0,0,211.2,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,60.31a2,2,0,1,0-2-2A2,2,0,0,0,219.24,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,60.31a2,2,0,1,0-2-2A2,2,0,0,0,227.29,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,60.31a2,2,0,1,0-2-2A2,2,0,0,0,235.33,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,60.31a2,2,0,1,0-2-2A2,2,0,0,0,243.38,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,60.31a2,2,0,1,0-2-2A2,2,0,0,0,251.43,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,60.31a2,2,0,1,0-2-2A2,2,0,0,0,259.47,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,60.31a2,2,0,1,0-2-2A2,2,0,0,0,267.52,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,60.31a2,2,0,1,0-2-2A2,2,0,0,0,275.57,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,60.31a2,2,0,1,0-2-2A2,2,0,0,0,283.61,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,60.31a2,2,0,1,0-2-2A2,2,0,0,0,291.66,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,60.31a2,2,0,1,0-2-2A2,2,0,0,0,299.7,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,60.31a2,2,0,1,0-2-2A2,2,0,0,0,307.75,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,60.31a2,2,0,1,0-2-2A2,2,0,0,0,315.8,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,60.31a2,2,0,1,0-2-2A2,2,0,0,0,323.84,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,60.31a2,2,0,1,0-2-2A2,2,0,0,0,331.89,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,60.31a2,2,0,1,0-2-2A2,2,0,0,0,339.94,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,60.31a2,2,0,1,0-2-2A2,2,0,0,0,348,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,60.31a2,2,0,1,0-2-2A2,2,0,0,0,356,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,60.31a2,2,0,1,0-2-2A2,2,0,0,0,364.08,60.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,68.35a2,2,0,1,0-2-2A2,2,0,0,0,114.64,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,68.35a2,2,0,1,0-2-2A2,2,0,0,0,122.69,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,68.35a2,2,0,1,0-2-2A2,2,0,0,0,130.73,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,68.35a2,2,0,1,0-2-2A2,2,0,0,0,138.78,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,68.35a2,2,0,1,0-2-2A2,2,0,0,0,146.83,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,68.35a2,2,0,1,0-2-2A2,2,0,0,0,154.87,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,68.35a2,2,0,1,0-2-2A2,2,0,0,0,162.92,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,68.35a2,2,0,1,0-2-2A2,2,0,0,0,171,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,68.35a2,2,0,1,0-2-2A2,2,0,0,0,179,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,68.35a2,2,0,1,0-2-2A2,2,0,0,0,187.06,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,68.35a2,2,0,1,0-2-2A2,2,0,0,0,195.1,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,68.35a2,2,0,1,0-2-2A2,2,0,0,0,203.15,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,68.35a2,2,0,1,0-2-2A2,2,0,0,0,211.2,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,68.35a2,2,0,1,0-2-2A2,2,0,0,0,219.24,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,68.35a2,2,0,1,0-2-2A2,2,0,0,0,227.29,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,68.35a2,2,0,1,0-2-2A2,2,0,0,0,235.33,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,68.35a2,2,0,1,0-2-2A2,2,0,0,0,243.38,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,68.35a2,2,0,1,0-2-2A2,2,0,0,0,251.43,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,68.35a2,2,0,1,0-2-2A2,2,0,0,0,259.47,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,68.35a2,2,0,1,0-2-2A2,2,0,0,0,267.52,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,68.35a2,2,0,1,0-2-2A2,2,0,0,0,275.57,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,68.35a2,2,0,1,0-2-2A2,2,0,0,0,283.61,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,68.35a2,2,0,1,0-2-2A2,2,0,0,0,291.66,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,68.35a2,2,0,1,0-2-2A2,2,0,0,0,299.7,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,68.35a2,2,0,1,0-2-2A2,2,0,0,0,307.75,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,68.35a2,2,0,1,0-2-2A2,2,0,0,0,315.8,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,68.35a2,2,0,1,0-2-2A2,2,0,0,0,323.84,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,68.35a2,2,0,1,0-2-2A2,2,0,0,0,331.89,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,68.35a2,2,0,1,0-2-2A2,2,0,0,0,339.94,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,68.35a2,2,0,1,0-2-2A2,2,0,0,0,348,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,68.35a2,2,0,1,0-2-2A2,2,0,0,0,356,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,68.35a2,2,0,1,0-2-2A2,2,0,0,0,364.08,68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,76.4a2,2,0,1,0-2-2A2,2,0,0,0,90.5,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,76.4a2,2,0,1,0-2-2A2,2,0,0,0,98.55,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,76.4a2,2,0,1,0-2-2A2,2,0,0,0,106.59,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,76.4a2,2,0,1,0-2-2A2,2,0,0,0,114.64,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,76.4a2,2,0,1,0-2-2A2,2,0,0,0,122.69,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,76.4a2,2,0,1,0-2-2A2,2,0,0,0,130.73,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,76.4a2,2,0,1,0-2-2A2,2,0,0,0,138.78,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,76.4a2,2,0,1,0-2-2A2,2,0,0,0,146.83,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,76.4a2,2,0,1,0-2-2A2,2,0,0,0,154.87,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,76.4a2,2,0,1,0-2-2A2,2,0,0,0,162.92,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,76.4a2,2,0,1,0-2-2A2,2,0,0,0,171,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,76.4a2,2,0,1,0-2-2A2,2,0,0,0,179,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,76.4a2,2,0,1,0-2-2A2,2,0,0,0,187.06,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,76.4a2,2,0,1,0-2-2A2,2,0,0,0,195.1,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,76.4a2,2,0,1,0-2-2A2,2,0,0,0,203.15,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,76.4a2,2,0,1,0-2-2A2,2,0,0,0,211.2,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,76.4a2,2,0,1,0-2-2A2,2,0,0,0,219.24,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,76.4a2,2,0,1,0-2-2A2,2,0,0,0,227.29,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,76.4a2,2,0,1,0-2-2A2,2,0,0,0,235.33,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,76.4a2,2,0,1,0-2-2A2,2,0,0,0,243.38,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,76.4a2,2,0,1,0-2-2A2,2,0,0,0,251.43,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,76.4a2,2,0,1,0-2-2A2,2,0,0,0,259.47,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,76.4a2,2,0,1,0-2-2A2,2,0,0,0,267.52,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,76.4a2,2,0,1,0-2-2A2,2,0,0,0,275.57,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,76.4a2,2,0,1,0-2-2A2,2,0,0,0,283.61,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,76.4a2,2,0,1,0-2-2A2,2,0,0,0,291.66,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,76.4a2,2,0,1,0-2-2A2,2,0,0,0,299.7,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,76.4a2,2,0,1,0-2-2A2,2,0,0,0,307.75,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,76.4a2,2,0,1,0-2-2A2,2,0,0,0,315.8,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,76.4a2,2,0,1,0-2-2A2,2,0,0,0,323.84,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,76.4a2,2,0,1,0-2-2A2,2,0,0,0,331.89,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,76.4a2,2,0,1,0-2-2A2,2,0,0,0,339.94,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,76.4a2,2,0,1,0-2-2A2,2,0,0,0,348,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,76.4a2,2,0,1,0-2-2A2,2,0,0,0,356,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,84.45a2,2,0,1,0-2-2A2,2,0,0,0,90.5,84.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.55,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,84.45a2,2,0,1,0-2-2A2,2,0,0,0,106.59,84.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,84.45a2,2,0,1,0-2-2A2,2,0,0,0,130.73,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,84.45a2,2,0,1,0-2-2A2,2,0,0,0,138.78,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,84.45a2,2,0,1,0-2-2A2,2,0,0,0,146.83,84.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,84.45a2,2,0,1,0-2-2A2,2,0,0,0,171,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,84.45a2,2,0,1,0-2-2A2,2,0,0,0,179,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,84.45a2,2,0,1,0-2-2A2,2,0,0,0,187.06,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,84.45a2,2,0,1,0-2-2A2,2,0,0,0,195.1,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,84.45a2,2,0,1,0-2-2A2,2,0,0,0,203.15,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,84.45a2,2,0,1,0-2-2A2,2,0,0,0,211.2,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,84.45a2,2,0,1,0-2-2A2,2,0,0,0,219.24,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,84.45a2,2,0,1,0-2-2A2,2,0,0,0,227.29,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,84.45a2,2,0,1,0-2-2A2,2,0,0,0,235.33,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,84.45a2,2,0,1,0-2-2A2,2,0,0,0,243.38,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,84.45a2,2,0,1,0-2-2A2,2,0,0,0,251.43,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,84.45a2,2,0,1,0-2-2A2,2,0,0,0,259.47,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,84.45a2,2,0,1,0-2-2A2,2,0,0,0,267.52,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,84.45a2,2,0,1,0-2-2A2,2,0,0,0,275.57,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,84.45a2,2,0,1,0-2-2A2,2,0,0,0,283.61,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,84.45a2,2,0,1,0-2-2A2,2,0,0,0,291.66,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,84.45a2,2,0,1,0-2-2A2,2,0,0,0,299.7,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,84.45a2,2,0,1,0-2-2A2,2,0,0,0,307.75,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,84.45a2,2,0,1,0-2-2A2,2,0,0,0,315.8,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,84.45a2,2,0,1,0-2-2A2,2,0,0,0,323.84,84.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.89,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 339.94,
    cy: 82.45,
    r: 1.99,
    transform: "translate(256.53 422.16) rotate(-89.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,84.45a2,2,0,1,0-2-2A2,2,0,0,0,348,84.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 356.03,
    cy: 82.45,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,84.45a2,2,0,1,0-2-2A2,2,0,0,0,396.26,84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,92.49a2,2,0,1,0-2-2A2,2,0,0,0,82.45,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,92.49a2,2,0,1,0-2-2A2,2,0,0,0,90.5,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,92.49a2,2,0,1,0-2-2A2,2,0,0,0,98.55,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,92.49a2,2,0,1,0-2-2A2,2,0,0,0,106.59,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,92.49a2,2,0,1,0-2-2A2,2,0,0,0,114.64,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,92.49a2,2,0,1,0-2-2A2,2,0,0,0,122.69,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,92.49a2,2,0,1,0-2-2A2,2,0,0,0,130.73,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,92.49a2,2,0,1,0-2-2A2,2,0,0,0,138.78,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,92.49a2,2,0,1,0-2-2A2,2,0,0,0,146.83,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,92.49a2,2,0,1,0-2-2A2,2,0,0,0,154.87,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,92.49a2,2,0,1,0-2-2A2,2,0,0,0,162.92,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,92.49a2,2,0,1,0-2-2A2,2,0,0,0,171,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,92.49a2,2,0,1,0-2-2A2,2,0,0,0,179,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,92.49a2,2,0,1,0-2-2A2,2,0,0,0,187.06,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,92.49a2,2,0,1,0-2-2A2,2,0,0,0,195.1,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,92.49a2,2,0,1,0-2-2A2,2,0,0,0,203.15,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,92.49a2,2,0,1,0-2-2A2,2,0,0,0,211.2,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,92.49a2,2,0,1,0-2-2A2,2,0,0,0,219.24,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,92.49a2,2,0,1,0-2-2A2,2,0,0,0,227.29,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,92.49a2,2,0,1,0-2-2A2,2,0,0,0,235.33,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,92.49a2,2,0,1,0-2-2A2,2,0,0,0,243.38,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,92.49a2,2,0,1,0-2-2A2,2,0,0,0,251.43,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,92.49a2,2,0,1,0-2-2A2,2,0,0,0,259.47,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,92.49a2,2,0,1,0-2-2A2,2,0,0,0,267.52,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,92.49a2,2,0,1,0-2-2A2,2,0,0,0,275.57,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,92.49a2,2,0,1,0-2-2A2,2,0,0,0,283.61,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,92.49a2,2,0,1,0-2-2A2,2,0,0,0,291.66,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,92.49a2,2,0,1,0-2-2A2,2,0,0,0,299.7,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,92.49a2,2,0,1,0-2-2A2,2,0,0,0,307.75,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,92.49a2,2,0,1,0-2-2A2,2,0,0,0,315.8,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,92.49a2,2,0,1,0-2-2A2,2,0,0,0,323.84,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,92.49a2,2,0,1,0-2-2A2,2,0,0,0,331.89,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,92.49a2,2,0,1,0-2-2A2,2,0,0,0,339.94,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,92.49a2,2,0,1,0-2-2A2,2,0,0,0,348,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,92.49a2,2,0,1,0-2-2A2,2,0,0,0,356,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,92.49a2,2,0,1,0-2-2A2,2,0,0,0,364.08,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,92.49a2,2,0,1,0-2-2A2,2,0,0,0,372.12,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,92.49a2,2,0,1,0-2-2A2,2,0,0,0,380.17,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,92.49a2,2,0,1,0-2-2A2,2,0,0,0,388.21,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,92.49a2,2,0,1,0-2-2A2,2,0,0,0,396.26,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,92.49a2,2,0,1,0-2-2A2,2,0,0,0,404.31,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,92.49a2,2,0,1,0-2-2A2,2,0,0,0,412.35,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,92.49a2,2,0,1,0-2-2A2,2,0,0,0,436.49,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,92.49a2,2,0,1,0-2-2A2,2,0,0,0,444.54,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.59,92.49a2,2,0,1,0-2-2A2,2,0,0,0,452.59,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.63,92.49a2,2,0,1,0-2-2A2,2,0,0,0,460.63,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,100.54a2,2,0,1,0-2-2A2,2,0,0,0,66.36,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,100.54a2,2,0,1,0-2-2A2,2,0,0,0,74.41,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,100.54a2,2,0,1,0-2-2A2,2,0,0,0,82.45,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,100.54a2,2,0,1,0-2-2A2,2,0,0,0,90.5,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,100.54a2,2,0,1,0-2-2A2,2,0,0,0,98.55,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,100.54a2,2,0,1,0-2-2A2,2,0,0,0,106.59,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,100.54a2,2,0,1,0-2-2A2,2,0,0,0,114.64,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,100.54a2,2,0,1,0-2-2A2,2,0,0,0,122.69,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,100.54a2,2,0,1,0-2-2A2,2,0,0,0,130.73,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,100.54a2,2,0,1,0-2-2A2,2,0,0,0,138.78,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,100.54a2,2,0,1,0-2-2A2,2,0,0,0,146.83,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,100.54a2,2,0,1,0-2-2A2,2,0,0,0,154.87,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,100.54a2,2,0,1,0-2-2A2,2,0,0,0,162.92,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,100.54a2,2,0,1,0-2-2A2,2,0,0,0,171,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,100.54a2,2,0,1,0-2-2A2,2,0,0,0,179,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,100.54a2,2,0,1,0-2-2A2,2,0,0,0,187.06,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,100.54a2,2,0,1,0-2-2A2,2,0,0,0,195.1,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,100.54a2,2,0,1,0-2-2A2,2,0,0,0,203.15,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,100.54a2,2,0,1,0-2-2A2,2,0,0,0,211.2,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,100.54a2,2,0,1,0-2-2A2,2,0,0,0,219.24,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,100.54a2,2,0,1,0-2-2A2,2,0,0,0,227.29,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,100.54a2,2,0,1,0-2-2A2,2,0,0,0,235.33,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,100.54a2,2,0,1,0-2-2A2,2,0,0,0,243.38,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,100.54a2,2,0,1,0-2-2A2,2,0,0,0,251.43,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,100.54a2,2,0,1,0-2-2A2,2,0,0,0,259.47,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,100.54a2,2,0,1,0-2-2A2,2,0,0,0,267.52,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,100.54a2,2,0,1,0-2-2A2,2,0,0,0,275.57,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,100.54a2,2,0,1,0-2-2A2,2,0,0,0,283.61,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,100.54a2,2,0,1,0-2-2A2,2,0,0,0,291.66,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,100.54a2,2,0,1,0-2-2A2,2,0,0,0,299.7,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,100.54a2,2,0,1,0-2-2A2,2,0,0,0,307.75,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,100.54a2,2,0,1,0-2-2A2,2,0,0,0,315.8,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,100.54a2,2,0,1,0-2-2A2,2,0,0,0,323.84,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,100.54a2,2,0,1,0-2-2A2,2,0,0,0,331.89,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,100.54a2,2,0,1,0-2-2A2,2,0,0,0,339.94,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,100.54a2,2,0,1,0-2-2A2,2,0,0,0,348,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,100.54a2,2,0,1,0-2-2A2,2,0,0,0,356,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,100.54a2,2,0,1,0-2-2A2,2,0,0,0,364.08,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,100.54a2,2,0,1,0-2-2A2,2,0,0,0,372.12,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,100.54a2,2,0,1,0-2-2A2,2,0,0,0,380.17,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,100.54a2,2,0,1,0-2-2A2,2,0,0,0,388.21,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,100.54a2,2,0,1,0-2-2A2,2,0,0,0,396.26,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,100.54a2,2,0,1,0-2-2A2,2,0,0,0,404.31,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,100.54a2,2,0,1,0-2-2A2,2,0,0,0,412.35,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,100.54a2,2,0,1,0-2-2A2,2,0,0,0,420.4,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,100.54a2,2,0,1,0-2-2A2,2,0,0,0,428.45,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,100.54a2,2,0,1,0-2-2A2,2,0,0,0,436.49,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,100.54a2,2,0,1,0-2-2A2,2,0,0,0,444.54,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.59,100.54a2,2,0,1,0-2-2A2,2,0,0,0,452.59,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.63,100.54a2,2,0,1,0-2-2A2,2,0,0,0,460.63,100.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,108.58a2,2,0,1,0-2-2A2,2,0,0,0,58.32,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,108.58a2,2,0,1,0-2-2A2,2,0,0,0,66.36,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,108.58a2,2,0,1,0-2-2A2,2,0,0,0,74.41,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,108.58a2,2,0,1,0-2-2A2,2,0,0,0,82.45,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,108.58a2,2,0,1,0-2-2A2,2,0,0,0,90.5,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,108.58a2,2,0,1,0-2-2A2,2,0,0,0,98.55,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,108.58a2,2,0,1,0-2-2A2,2,0,0,0,106.59,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,108.58a2,2,0,1,0-2-2A2,2,0,0,0,114.64,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,108.58a2,2,0,1,0-2-2A2,2,0,0,0,122.69,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,108.58a2,2,0,1,0-2-2A2,2,0,0,0,130.73,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,108.58a2,2,0,1,0-2-2A2,2,0,0,0,138.78,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,108.58a2,2,0,1,0-2-2A2,2,0,0,0,146.83,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,108.58a2,2,0,1,0-2-2A2,2,0,0,0,154.87,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,108.58a2,2,0,1,0-2-2A2,2,0,0,0,162.92,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,108.58a2,2,0,1,0-2-2A2,2,0,0,0,171,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,108.58a2,2,0,1,0-2-2A2,2,0,0,0,179,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,108.58a2,2,0,1,0-2-2A2,2,0,0,0,187.06,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,108.58a2,2,0,1,0-2-2A2,2,0,0,0,195.1,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,108.58a2,2,0,1,0-2-2A2,2,0,0,0,203.15,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,108.58a2,2,0,1,0-2-2A2,2,0,0,0,211.2,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,108.58a2,2,0,1,0-2-2A2,2,0,0,0,219.24,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,108.58a2,2,0,1,0-2-2A2,2,0,0,0,227.29,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,108.58a2,2,0,1,0-2-2A2,2,0,0,0,235.33,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,108.58a2,2,0,1,0-2-2A2,2,0,0,0,243.38,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,108.58a2,2,0,1,0-2-2A2,2,0,0,0,251.43,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,108.58a2,2,0,1,0-2-2A2,2,0,0,0,259.47,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,108.58a2,2,0,1,0-2-2A2,2,0,0,0,267.52,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,108.58a2,2,0,1,0-2-2A2,2,0,0,0,275.57,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,108.58a2,2,0,1,0-2-2A2,2,0,0,0,283.61,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,108.58a2,2,0,1,0-2-2A2,2,0,0,0,291.66,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,108.58a2,2,0,1,0-2-2A2,2,0,0,0,299.7,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,108.58a2,2,0,1,0-2-2A2,2,0,0,0,307.75,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,108.58a2,2,0,1,0-2-2A2,2,0,0,0,315.8,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,108.58a2,2,0,1,0-2-2A2,2,0,0,0,323.84,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,108.58a2,2,0,1,0-2-2A2,2,0,0,0,331.89,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,108.58a2,2,0,1,0-2-2A2,2,0,0,0,339.94,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,108.58a2,2,0,1,0-2-2A2,2,0,0,0,348,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,108.58a2,2,0,1,0-2-2A2,2,0,0,0,356,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,108.58a2,2,0,1,0-2-2A2,2,0,0,0,364.08,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,108.58a2,2,0,1,0-2-2A2,2,0,0,0,372.12,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,108.58a2,2,0,1,0-2-2A2,2,0,0,0,380.17,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,108.58a2,2,0,1,0-2-2A2,2,0,0,0,388.21,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,108.58a2,2,0,1,0-2-2A2,2,0,0,0,396.26,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,108.58a2,2,0,1,0-2-2A2,2,0,0,0,404.31,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,108.58a2,2,0,1,0-2-2A2,2,0,0,0,412.35,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,108.58a2,2,0,1,0-2-2A2,2,0,0,0,420.4,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,108.58a2,2,0,1,0-2-2A2,2,0,0,0,428.45,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,108.58a2,2,0,1,0-2-2A2,2,0,0,0,436.49,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,108.58a2,2,0,1,0-2-2A2,2,0,0,0,444.54,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.59,108.58a2,2,0,1,0-2-2A2,2,0,0,0,452.59,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.63,108.58a2,2,0,1,0-2-2A2,2,0,0,0,460.63,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,116.63a2,2,0,1,0-2-2A2,2,0,0,0,50.27,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,116.63a2,2,0,1,0-2-2A2,2,0,0,0,58.32,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,116.63a2,2,0,1,0-2-2A2,2,0,0,0,66.36,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,116.63a2,2,0,1,0-2-2A2,2,0,0,0,74.41,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,116.63a2,2,0,1,0-2-2A2,2,0,0,0,82.45,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,116.63a2,2,0,1,0-2-2A2,2,0,0,0,90.5,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,116.63a2,2,0,1,0-2-2A2,2,0,0,0,98.55,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,116.63a2,2,0,1,0-2-2A2,2,0,0,0,106.59,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,116.63a2,2,0,1,0-2-2A2,2,0,0,0,114.64,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,116.63a2,2,0,1,0-2-2A2,2,0,0,0,122.69,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,116.63a2,2,0,1,0-2-2A2,2,0,0,0,130.73,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,116.63a2,2,0,1,0-2-2A2,2,0,0,0,138.78,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,116.63a2,2,0,1,0-2-2A2,2,0,0,0,146.83,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,116.63a2,2,0,1,0-2-2A2,2,0,0,0,154.87,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,116.63a2,2,0,1,0-2-2A2,2,0,0,0,162.92,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,116.63a2,2,0,1,0-2-2A2,2,0,0,0,171,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,116.63a2,2,0,1,0-2-2A2,2,0,0,0,179,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,116.63a2,2,0,1,0-2-2A2,2,0,0,0,187.06,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,116.63a2,2,0,1,0-2-2A2,2,0,0,0,195.1,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,116.63a2,2,0,1,0-2-2A2,2,0,0,0,203.15,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,116.63a2,2,0,1,0-2-2A2,2,0,0,0,211.2,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,116.63a2,2,0,1,0-2-2A2,2,0,0,0,219.24,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,116.63a2,2,0,1,0-2-2A2,2,0,0,0,227.29,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,116.63a2,2,0,1,0-2-2A2,2,0,0,0,235.33,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,116.63a2,2,0,1,0-2-2A2,2,0,0,0,243.38,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,116.63a2,2,0,1,0-2-2A2,2,0,0,0,251.43,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,116.63a2,2,0,1,0-2-2A2,2,0,0,0,259.47,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,116.63a2,2,0,1,0-2-2A2,2,0,0,0,267.52,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,116.63a2,2,0,1,0-2-2A2,2,0,0,0,275.57,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,116.63a2,2,0,1,0-2-2A2,2,0,0,0,283.61,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,116.63a2,2,0,1,0-2-2A2,2,0,0,0,291.66,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,116.63a2,2,0,1,0-2-2A2,2,0,0,0,299.7,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,116.63a2,2,0,1,0-2-2A2,2,0,0,0,307.75,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,116.63a2,2,0,1,0-2-2A2,2,0,0,0,315.8,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,116.63a2,2,0,1,0-2-2A2,2,0,0,0,323.84,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,116.63a2,2,0,1,0-2-2A2,2,0,0,0,331.89,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,116.63a2,2,0,1,0-2-2A2,2,0,0,0,339.94,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,116.63a2,2,0,1,0-2-2A2,2,0,0,0,348,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,116.63a2,2,0,1,0-2-2A2,2,0,0,0,356,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,116.63a2,2,0,1,0-2-2A2,2,0,0,0,364.08,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,116.63a2,2,0,1,0-2-2A2,2,0,0,0,372.12,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,116.63a2,2,0,1,0-2-2A2,2,0,0,0,380.17,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,116.63a2,2,0,1,0-2-2A2,2,0,0,0,388.21,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,116.63a2,2,0,1,0-2-2A2,2,0,0,0,396.26,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,116.63a2,2,0,1,0-2-2A2,2,0,0,0,404.31,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,116.63a2,2,0,1,0-2-2A2,2,0,0,0,412.35,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,116.63a2,2,0,1,0-2-2A2,2,0,0,0,420.4,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,116.63a2,2,0,1,0-2-2A2,2,0,0,0,428.45,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,116.63a2,2,0,1,0-2-2A2,2,0,0,0,436.49,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,116.63a2,2,0,1,0-2-2A2,2,0,0,0,444.54,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.59,116.63a2,2,0,1,0-2-2A2,2,0,0,0,452.59,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.63,116.63a2,2,0,1,0-2-2A2,2,0,0,0,460.63,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,124.68a2,2,0,1,0-2-2A2,2,0,0,0,42.22,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,124.68a2,2,0,1,0-2-2A2,2,0,0,0,50.27,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,124.68a2,2,0,1,0-2-2A2,2,0,0,0,58.32,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,124.68a2,2,0,1,0-2-2A2,2,0,0,0,66.36,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,124.68a2,2,0,1,0-2-2A2,2,0,0,0,74.41,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,124.68a2,2,0,1,0-2-2A2,2,0,0,0,82.45,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,124.68a2,2,0,1,0-2-2A2,2,0,0,0,90.5,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,124.68a2,2,0,1,0-2-2A2,2,0,0,0,98.55,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,124.68a2,2,0,1,0-2-2A2,2,0,0,0,106.59,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,124.68a2,2,0,1,0-2-2A2,2,0,0,0,114.64,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,124.68a2,2,0,1,0-2-2A2,2,0,0,0,122.69,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,124.68a2,2,0,1,0-2-2A2,2,0,0,0,130.73,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,124.68a2,2,0,1,0-2-2A2,2,0,0,0,138.78,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,124.68a2,2,0,1,0-2-2A2,2,0,0,0,146.83,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,124.68a2,2,0,1,0-2-2A2,2,0,0,0,154.87,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,124.68a2,2,0,1,0-2-2A2,2,0,0,0,162.92,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,124.68a2,2,0,1,0-2-2A2,2,0,0,0,171,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,124.68a2,2,0,1,0-2-2A2,2,0,0,0,179,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,124.68a2,2,0,1,0-2-2A2,2,0,0,0,187.06,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,124.68a2,2,0,1,0-2-2A2,2,0,0,0,195.1,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,124.68a2,2,0,1,0-2-2A2,2,0,0,0,203.15,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,124.68a2,2,0,1,0-2-2A2,2,0,0,0,211.2,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,124.68a2,2,0,1,0-2-2A2,2,0,0,0,219.24,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,124.68a2,2,0,1,0-2-2A2,2,0,0,0,227.29,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,124.68a2,2,0,1,0-2-2A2,2,0,0,0,235.33,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,124.68a2,2,0,1,0-2-2A2,2,0,0,0,243.38,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,124.68a2,2,0,1,0-2-2A2,2,0,0,0,251.43,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,124.68a2,2,0,1,0-2-2A2,2,0,0,0,259.47,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,124.68a2,2,0,1,0-2-2A2,2,0,0,0,267.52,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,124.68a2,2,0,1,0-2-2A2,2,0,0,0,275.57,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,124.68a2,2,0,1,0-2-2A2,2,0,0,0,283.61,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,124.68a2,2,0,1,0-2-2A2,2,0,0,0,291.66,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,124.68a2,2,0,1,0-2-2A2,2,0,0,0,299.7,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,124.68a2,2,0,1,0-2-2A2,2,0,0,0,307.75,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,124.68a2,2,0,1,0-2-2A2,2,0,0,0,315.8,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,124.68a2,2,0,1,0-2-2A2,2,0,0,0,323.84,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,124.68a2,2,0,1,0-2-2A2,2,0,0,0,331.89,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,124.68a2,2,0,1,0-2-2A2,2,0,0,0,339.94,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,124.68a2,2,0,1,0-2-2A2,2,0,0,0,348,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,124.68a2,2,0,1,0-2-2A2,2,0,0,0,356,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,124.68a2,2,0,1,0-2-2A2,2,0,0,0,364.08,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,124.68a2,2,0,1,0-2-2A2,2,0,0,0,372.12,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,124.68a2,2,0,1,0-2-2A2,2,0,0,0,380.17,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,124.68a2,2,0,1,0-2-2A2,2,0,0,0,388.21,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,124.68a2,2,0,1,0-2-2A2,2,0,0,0,396.26,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,124.68a2,2,0,1,0-2-2A2,2,0,0,0,404.31,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,124.68a2,2,0,1,0-2-2A2,2,0,0,0,412.35,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,124.68a2,2,0,1,0-2-2A2,2,0,0,0,420.4,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,124.68a2,2,0,1,0-2-2A2,2,0,0,0,428.45,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,124.68a2,2,0,1,0-2-2A2,2,0,0,0,436.49,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,124.68a2,2,0,1,0-2-2A2,2,0,0,0,444.54,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.59,124.68a2,2,0,1,0-2-2A2,2,0,0,0,452.59,124.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,132.72a2,2,0,1,0-2-2A2,2,0,0,0,42.22,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,132.72a2,2,0,1,0-2-2A2,2,0,0,0,50.27,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,132.72a2,2,0,1,0-2-2A2,2,0,0,0,58.32,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,132.72a2,2,0,1,0-2-2A2,2,0,0,0,66.36,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,132.72a2,2,0,1,0-2-2A2,2,0,0,0,74.41,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,132.72a2,2,0,1,0-2-2A2,2,0,0,0,82.45,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,132.72a2,2,0,1,0-2-2A2,2,0,0,0,90.5,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,132.72a2,2,0,1,0-2-2A2,2,0,0,0,98.55,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,132.72a2,2,0,1,0-2-2A2,2,0,0,0,106.59,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,132.72a2,2,0,1,0-2-2A2,2,0,0,0,114.64,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,132.72a2,2,0,1,0-2-2A2,2,0,0,0,122.69,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,132.72a2,2,0,1,0-2-2A2,2,0,0,0,130.73,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,132.72a2,2,0,1,0-2-2A2,2,0,0,0,138.78,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,132.72a2,2,0,1,0-2-2A2,2,0,0,0,146.83,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,132.72a2,2,0,1,0-2-2A2,2,0,0,0,154.87,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,132.72a2,2,0,1,0-2-2A2,2,0,0,0,162.92,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,132.72a2,2,0,1,0-2-2A2,2,0,0,0,171,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,132.72a2,2,0,1,0-2-2A2,2,0,0,0,179,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,132.72a2,2,0,1,0-2-2A2,2,0,0,0,187.06,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,132.72a2,2,0,1,0-2-2A2,2,0,0,0,195.1,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,132.72a2,2,0,1,0-2-2A2,2,0,0,0,203.15,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,132.72a2,2,0,1,0-2-2A2,2,0,0,0,211.2,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,132.72a2,2,0,1,0-2-2A2,2,0,0,0,219.24,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,132.72a2,2,0,1,0-2-2A2,2,0,0,0,227.29,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,132.72a2,2,0,1,0-2-2A2,2,0,0,0,235.33,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,132.72a2,2,0,1,0-2-2A2,2,0,0,0,243.38,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,132.72a2,2,0,1,0-2-2A2,2,0,0,0,251.43,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,132.72a2,2,0,1,0-2-2A2,2,0,0,0,259.47,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,132.72a2,2,0,1,0-2-2A2,2,0,0,0,267.52,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,132.72a2,2,0,1,0-2-2A2,2,0,0,0,275.57,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,132.72a2,2,0,1,0-2-2A2,2,0,0,0,283.61,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,132.72a2,2,0,1,0-2-2A2,2,0,0,0,291.66,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,132.72a2,2,0,1,0-2-2A2,2,0,0,0,299.7,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,132.72a2,2,0,1,0-2-2A2,2,0,0,0,307.75,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,132.72a2,2,0,1,0-2-2A2,2,0,0,0,315.8,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,132.72a2,2,0,1,0-2-2A2,2,0,0,0,323.84,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,132.72a2,2,0,1,0-2-2A2,2,0,0,0,331.89,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,132.72a2,2,0,1,0-2-2A2,2,0,0,0,339.94,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,132.72a2,2,0,1,0-2-2A2,2,0,0,0,348,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,132.72a2,2,0,1,0-2-2A2,2,0,0,0,356,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,132.72a2,2,0,1,0-2-2A2,2,0,0,0,364.08,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,132.72a2,2,0,1,0-2-2A2,2,0,0,0,372.12,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,132.72a2,2,0,1,0-2-2A2,2,0,0,0,380.17,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,132.72a2,2,0,1,0-2-2A2,2,0,0,0,388.21,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,132.72a2,2,0,1,0-2-2A2,2,0,0,0,396.26,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,132.72a2,2,0,1,0-2-2A2,2,0,0,0,404.31,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,132.72a2,2,0,1,0-2-2A2,2,0,0,0,412.35,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,132.72a2,2,0,1,0-2-2A2,2,0,0,0,420.4,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,132.72a2,2,0,1,0-2-2A2,2,0,0,0,428.45,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,132.72a2,2,0,1,0-2-2A2,2,0,0,0,436.49,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,132.72a2,2,0,1,0-2-2A2,2,0,0,0,444.54,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,140.77a2,2,0,1,0-2-2A2,2,0,0,0,34.18,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,140.77a2,2,0,1,0-2-2A2,2,0,0,0,42.22,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,140.77a2,2,0,1,0-2-2A2,2,0,0,0,50.27,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,140.77a2,2,0,1,0-2-2A2,2,0,0,0,58.32,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,140.77a2,2,0,1,0-2-2A2,2,0,0,0,66.36,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,140.77a2,2,0,1,0-2-2A2,2,0,0,0,74.41,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,140.77a2,2,0,1,0-2-2A2,2,0,0,0,82.45,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,140.77a2,2,0,1,0-2-2A2,2,0,0,0,90.5,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,140.77a2,2,0,1,0-2-2A2,2,0,0,0,98.55,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,140.77a2,2,0,1,0-2-2A2,2,0,0,0,106.59,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,140.77a2,2,0,1,0-2-2A2,2,0,0,0,114.64,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,140.77a2,2,0,1,0-2-2A2,2,0,0,0,122.69,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,140.77a2,2,0,1,0-2-2A2,2,0,0,0,130.73,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,140.77a2,2,0,1,0-2-2A2,2,0,0,0,138.78,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,140.77a2,2,0,1,0-2-2A2,2,0,0,0,146.83,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,140.77a2,2,0,1,0-2-2A2,2,0,0,0,154.87,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,140.77a2,2,0,1,0-2-2A2,2,0,0,0,162.92,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,140.77a2,2,0,1,0-2-2A2,2,0,0,0,171,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,140.77a2,2,0,1,0-2-2A2,2,0,0,0,179,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,140.77a2,2,0,1,0-2-2A2,2,0,0,0,187.06,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,140.77a2,2,0,1,0-2-2A2,2,0,0,0,195.1,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,140.77a2,2,0,1,0-2-2A2,2,0,0,0,203.15,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,140.77a2,2,0,1,0-2-2A2,2,0,0,0,211.2,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,140.77a2,2,0,1,0-2-2A2,2,0,0,0,219.24,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,140.77a2,2,0,1,0-2-2A2,2,0,0,0,227.29,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,140.77a2,2,0,1,0-2-2A2,2,0,0,0,235.33,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,140.77a2,2,0,1,0-2-2A2,2,0,0,0,243.38,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,140.77a2,2,0,1,0-2-2A2,2,0,0,0,251.43,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,140.77a2,2,0,1,0-2-2A2,2,0,0,0,259.47,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,140.77a2,2,0,1,0-2-2A2,2,0,0,0,267.52,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,140.77a2,2,0,1,0-2-2A2,2,0,0,0,275.57,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,140.77a2,2,0,1,0-2-2A2,2,0,0,0,283.61,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,140.77a2,2,0,1,0-2-2A2,2,0,0,0,291.66,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,140.77a2,2,0,1,0-2-2A2,2,0,0,0,299.7,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,140.77a2,2,0,1,0-2-2A2,2,0,0,0,307.75,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,140.77a2,2,0,1,0-2-2A2,2,0,0,0,315.8,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,140.77a2,2,0,1,0-2-2A2,2,0,0,0,323.84,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,140.77a2,2,0,1,0-2-2A2,2,0,0,0,331.89,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,140.77a2,2,0,1,0-2-2A2,2,0,0,0,339.94,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,140.77a2,2,0,1,0-2-2A2,2,0,0,0,348,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,140.77a2,2,0,1,0-2-2A2,2,0,0,0,356,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,140.77a2,2,0,1,0-2-2A2,2,0,0,0,364.08,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,140.77a2,2,0,1,0-2-2A2,2,0,0,0,372.12,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,140.77a2,2,0,1,0-2-2A2,2,0,0,0,380.17,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,140.77a2,2,0,1,0-2-2A2,2,0,0,0,388.21,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,140.77a2,2,0,1,0-2-2A2,2,0,0,0,396.26,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,140.77a2,2,0,1,0-2-2A2,2,0,0,0,404.31,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,140.77a2,2,0,1,0-2-2A2,2,0,0,0,412.35,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,140.77a2,2,0,1,0-2-2A2,2,0,0,0,420.4,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,140.77a2,2,0,1,0-2-2A2,2,0,0,0,428.45,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,140.77a2,2,0,1,0-2-2A2,2,0,0,0,436.49,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,140.77a2,2,0,1,0-2-2A2,2,0,0,0,444.54,140.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,148.82a2,2,0,1,0-2-2A2,2,0,0,0,34.18,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,148.82a2,2,0,1,0-2-2A2,2,0,0,0,42.22,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.27,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,148.82a2,2,0,1,0-2-2A2,2,0,0,0,58.32,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,148.82a2,2,0,1,0-2-2A2,2,0,0,0,66.36,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,148.82a2,2,0,1,0-2-2A2,2,0,0,0,74.41,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,148.82a2,2,0,1,0-2-2A2,2,0,0,0,82.45,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,148.82a2,2,0,1,0-2-2A2,2,0,0,0,90.5,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.55,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,148.82a2,2,0,1,0-2-2A2,2,0,0,0,106.59,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,148.82a2,2,0,1,0-2-2A2,2,0,0,0,130.73,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,148.82a2,2,0,1,0-2-2A2,2,0,0,0,138.78,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,148.82a2,2,0,1,0-2-2A2,2,0,0,0,146.83,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,148.82a2,2,0,1,0-2-2A2,2,0,0,0,171,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,148.82a2,2,0,1,0-2-2A2,2,0,0,0,179,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,148.82a2,2,0,1,0-2-2A2,2,0,0,0,187.06,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,148.82a2,2,0,1,0-2-2A2,2,0,0,0,195.1,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,148.82a2,2,0,1,0-2-2A2,2,0,0,0,203.15,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,148.82a2,2,0,1,0-2-2A2,2,0,0,0,211.2,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,148.82a2,2,0,1,0-2-2A2,2,0,0,0,219.24,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,148.82a2,2,0,1,0-2-2A2,2,0,0,0,227.29,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,148.82a2,2,0,1,0-2-2A2,2,0,0,0,235.33,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,148.82a2,2,0,1,0-2-2A2,2,0,0,0,243.38,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,148.82a2,2,0,1,0-2-2A2,2,0,0,0,251.43,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,148.82a2,2,0,1,0-2-2A2,2,0,0,0,259.47,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,148.82a2,2,0,1,0-2-2A2,2,0,0,0,267.52,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,148.82a2,2,0,1,0-2-2A2,2,0,0,0,275.57,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,148.82a2,2,0,1,0-2-2A2,2,0,0,0,283.61,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,148.82a2,2,0,1,0-2-2A2,2,0,0,0,291.66,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,148.82a2,2,0,1,0-2-2A2,2,0,0,0,299.7,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,148.82a2,2,0,1,0-2-2A2,2,0,0,0,307.75,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,148.82a2,2,0,1,0-2-2A2,2,0,0,0,315.8,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,148.82a2,2,0,1,0-2-2A2,2,0,0,0,323.84,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.89,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 339.94,
    cy: 146.83,
    r: 1.99,
    transform: "translate(192.16 486.35) rotate(-89.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,148.82a2,2,0,1,0-2-2A2,2,0,0,0,348,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 356.03,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,148.82a2,2,0,1,0-2-2A2,2,0,0,0,364.08,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,148.82a2,2,0,1,0-2-2A2,2,0,0,0,372.12,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,148.82a2,2,0,1,0-2-2A2,2,0,0,0,380.17,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,148.82a2,2,0,1,0-2-2A2,2,0,0,0,388.21,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,148.82a2,2,0,1,0-2-2A2,2,0,0,0,396.26,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,148.82a2,2,0,1,0-2-2A2,2,0,0,0,404.31,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,148.82a2,2,0,1,0-2-2A2,2,0,0,0,412.35,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,148.82a2,2,0,1,0-2-2A2,2,0,0,0,420.4,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 428.45,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,148.82a2,2,0,1,0-2-2A2,2,0,0,0,436.49,148.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,148.82a2,2,0,1,0-2-2A2,2,0,0,0,444.54,148.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 452.59,
    cy: 146.83,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,156.86a2,2,0,1,0-2-2A2,2,0,0,0,34.18,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,156.86a2,2,0,1,0-2-2A2,2,0,0,0,42.22,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.27,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,156.86a2,2,0,1,0-2-2A2,2,0,0,0,58.32,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,156.86a2,2,0,1,0-2-2A2,2,0,0,0,66.36,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,156.86a2,2,0,1,0-2-2A2,2,0,0,0,74.41,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,156.86a2,2,0,1,0-2-2A2,2,0,0,0,82.45,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,156.86a2,2,0,1,0-2-2A2,2,0,0,0,90.5,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.55,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,156.86a2,2,0,1,0-2-2A2,2,0,0,0,106.59,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,156.86a2,2,0,1,0-2-2A2,2,0,0,0,130.73,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,156.86a2,2,0,1,0-2-2A2,2,0,0,0,138.78,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,156.86a2,2,0,1,0-2-2A2,2,0,0,0,146.83,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,156.86a2,2,0,1,0-2-2A2,2,0,0,0,171,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,156.86a2,2,0,1,0-2-2A2,2,0,0,0,179,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,156.86a2,2,0,1,0-2-2A2,2,0,0,0,187.06,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,156.86a2,2,0,1,0-2-2A2,2,0,0,0,195.1,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,156.86a2,2,0,1,0-2-2A2,2,0,0,0,203.15,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,156.86a2,2,0,1,0-2-2A2,2,0,0,0,211.2,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,156.86a2,2,0,1,0-2-2A2,2,0,0,0,219.24,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,156.86a2,2,0,1,0-2-2A2,2,0,0,0,227.29,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,156.86a2,2,0,1,0-2-2A2,2,0,0,0,235.33,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,156.86a2,2,0,1,0-2-2A2,2,0,0,0,243.38,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,156.86a2,2,0,1,0-2-2A2,2,0,0,0,251.43,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,156.86a2,2,0,1,0-2-2A2,2,0,0,0,259.47,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,156.86a2,2,0,1,0-2-2A2,2,0,0,0,267.52,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,156.86a2,2,0,1,0-2-2A2,2,0,0,0,275.57,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,156.86a2,2,0,1,0-2-2A2,2,0,0,0,283.61,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,156.86a2,2,0,1,0-2-2A2,2,0,0,0,291.66,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,156.86a2,2,0,1,0-2-2A2,2,0,0,0,299.7,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,156.86a2,2,0,1,0-2-2A2,2,0,0,0,307.75,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,156.86a2,2,0,1,0-2-2A2,2,0,0,0,315.8,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,156.86a2,2,0,1,0-2-2A2,2,0,0,0,323.84,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.89,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 339.94,
    cy: 154.87,
    r: 1.99,
    transform: "translate(184.11 494.37) rotate(-89.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,156.86a2,2,0,1,0-2-2A2,2,0,0,0,348,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 356.03,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,156.86a2,2,0,1,0-2-2A2,2,0,0,0,364.08,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,156.86a2,2,0,1,0-2-2A2,2,0,0,0,372.12,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,156.86a2,2,0,1,0-2-2A2,2,0,0,0,380.17,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,156.86a2,2,0,1,0-2-2A2,2,0,0,0,388.21,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,156.86a2,2,0,1,0-2-2A2,2,0,0,0,396.26,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,156.86a2,2,0,1,0-2-2A2,2,0,0,0,404.31,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,156.86a2,2,0,1,0-2-2A2,2,0,0,0,412.35,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,156.86a2,2,0,1,0-2-2A2,2,0,0,0,420.4,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 428.45,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,156.86a2,2,0,1,0-2-2A2,2,0,0,0,436.49,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,156.86a2,2,0,1,0-2-2A2,2,0,0,0,444.54,156.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 452.59,
    cy: 154.87,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,164.91a2,2,0,1,0-2-2A2,2,0,0,0,26.13,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,164.91a2,2,0,1,0-2-2A2,2,0,0,0,34.18,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,164.91a2,2,0,1,0-2-2A2,2,0,0,0,42.22,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,164.91a2,2,0,1,0-2-2A2,2,0,0,0,50.27,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,164.91a2,2,0,1,0-2-2A2,2,0,0,0,58.32,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,164.91a2,2,0,1,0-2-2A2,2,0,0,0,66.36,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,164.91a2,2,0,1,0-2-2A2,2,0,0,0,74.41,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,164.91a2,2,0,1,0-2-2A2,2,0,0,0,82.45,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,164.91a2,2,0,1,0-2-2A2,2,0,0,0,90.5,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,164.91a2,2,0,1,0-2-2A2,2,0,0,0,98.55,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,164.91a2,2,0,1,0-2-2A2,2,0,0,0,106.59,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,164.91a2,2,0,1,0-2-2A2,2,0,0,0,114.64,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,164.91a2,2,0,1,0-2-2A2,2,0,0,0,122.69,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,164.91a2,2,0,1,0-2-2A2,2,0,0,0,130.73,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,164.91a2,2,0,1,0-2-2A2,2,0,0,0,138.78,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,164.91a2,2,0,1,0-2-2A2,2,0,0,0,146.83,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,164.91a2,2,0,1,0-2-2A2,2,0,0,0,154.87,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,164.91a2,2,0,1,0-2-2A2,2,0,0,0,162.92,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,164.91a2,2,0,1,0-2-2A2,2,0,0,0,171,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,164.91a2,2,0,1,0-2-2A2,2,0,0,0,179,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,164.91a2,2,0,1,0-2-2A2,2,0,0,0,187.06,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,164.91a2,2,0,1,0-2-2A2,2,0,0,0,195.1,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,164.91a2,2,0,1,0-2-2A2,2,0,0,0,203.15,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,164.91a2,2,0,1,0-2-2A2,2,0,0,0,211.2,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,164.91a2,2,0,1,0-2-2A2,2,0,0,0,219.24,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,164.91a2,2,0,1,0-2-2A2,2,0,0,0,227.29,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,164.91a2,2,0,1,0-2-2A2,2,0,0,0,235.33,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,164.91a2,2,0,1,0-2-2A2,2,0,0,0,243.38,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,164.91a2,2,0,1,0-2-2A2,2,0,0,0,251.43,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,164.91a2,2,0,1,0-2-2A2,2,0,0,0,259.47,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,164.91a2,2,0,1,0-2-2A2,2,0,0,0,267.52,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,164.91a2,2,0,1,0-2-2A2,2,0,0,0,275.57,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,164.91a2,2,0,1,0-2-2A2,2,0,0,0,283.61,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,164.91a2,2,0,1,0-2-2A2,2,0,0,0,291.66,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,164.91a2,2,0,1,0-2-2A2,2,0,0,0,299.7,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,164.91a2,2,0,1,0-2-2A2,2,0,0,0,307.75,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,164.91a2,2,0,1,0-2-2A2,2,0,0,0,315.8,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,164.91a2,2,0,1,0-2-2A2,2,0,0,0,323.84,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,164.91a2,2,0,1,0-2-2A2,2,0,0,0,331.89,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,164.91a2,2,0,1,0-2-2A2,2,0,0,0,339.94,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,164.91a2,2,0,1,0-2-2A2,2,0,0,0,348,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,164.91a2,2,0,1,0-2-2A2,2,0,0,0,356,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,164.91a2,2,0,1,0-2-2A2,2,0,0,0,364.08,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,164.91a2,2,0,1,0-2-2A2,2,0,0,0,372.12,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,164.91a2,2,0,1,0-2-2A2,2,0,0,0,380.17,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,164.91a2,2,0,1,0-2-2A2,2,0,0,0,388.21,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,164.91a2,2,0,1,0-2-2A2,2,0,0,0,396.26,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,164.91a2,2,0,1,0-2-2A2,2,0,0,0,404.31,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,164.91a2,2,0,1,0-2-2A2,2,0,0,0,412.35,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.4,164.91a2,2,0,1,0-2-2A2,2,0,0,0,420.4,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,164.91a2,2,0,1,0-2-2A2,2,0,0,0,428.45,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.49,164.91a2,2,0,1,0-2-2A2,2,0,0,0,436.49,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.54,164.91a2,2,0,1,0-2-2A2,2,0,0,0,444.54,164.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,173a2,2,0,1,0-2-2A2,2,0,0,0,26.13,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,173a2,2,0,1,0-2-2A2,2,0,0,0,34.18,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,173a2,2,0,1,0-2-2A2,2,0,0,0,42.22,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,173a2,2,0,1,0-2-2A2,2,0,0,0,50.27,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,173a2,2,0,1,0-2-2A2,2,0,0,0,58.32,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.36,173a2,2,0,1,0-2-2A2,2,0,0,0,66.36,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,173a2,2,0,1,0-2-2A2,2,0,0,0,74.41,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.45,173a2,2,0,1,0-2-2A2,2,0,0,0,82.45,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,173a2,2,0,1,0-2-2A2,2,0,0,0,90.5,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,173a2,2,0,1,0-2-2A2,2,0,0,0,98.55,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,173a2,2,0,1,0-2-2A2,2,0,0,0,106.59,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,173a2,2,0,1,0-2-2A2,2,0,0,0,114.64,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,173a2,2,0,1,0-2-2A2,2,0,0,0,122.69,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,173a2,2,0,1,0-2-2A2,2,0,0,0,130.73,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,173a2,2,0,1,0-2-2A2,2,0,0,0,138.78,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,173a2,2,0,1,0-2-2A2,2,0,0,0,146.83,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,173a2,2,0,1,0-2-2A2,2,0,0,0,154.87,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,173a2,2,0,1,0-2-2A2,2,0,0,0,162.92,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,173a2,2,0,1,0-2-2A2,2,0,0,0,171,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,173a2,2,0,1,0-2-2A2,2,0,0,0,179,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,173a2,2,0,1,0-2-2A2,2,0,0,0,187.06,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,173a2,2,0,1,0-2-2A2,2,0,0,0,195.1,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,173a2,2,0,1,0-2-2A2,2,0,0,0,203.15,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,173a2,2,0,1,0-2-2A2,2,0,0,0,211.2,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,173a2,2,0,1,0-2-2A2,2,0,0,0,219.24,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,173a2,2,0,1,0-2-2A2,2,0,0,0,227.29,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,173a2,2,0,1,0-2-2A2,2,0,0,0,235.33,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,173a2,2,0,1,0-2-2A2,2,0,0,0,243.38,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.43,173a2,2,0,1,0-2-2A2,2,0,0,0,251.43,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,173a2,2,0,1,0-2-2A2,2,0,0,0,259.47,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,173a2,2,0,1,0-2-2A2,2,0,0,0,267.52,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,173a2,2,0,1,0-2-2A2,2,0,0,0,275.57,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,173a2,2,0,1,0-2-2A2,2,0,0,0,283.61,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,173a2,2,0,1,0-2-2A2,2,0,0,0,291.66,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,173a2,2,0,1,0-2-2A2,2,0,0,0,299.7,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,173a2,2,0,1,0-2-2A2,2,0,0,0,307.75,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,173a2,2,0,1,0-2-2A2,2,0,0,0,315.8,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,173a2,2,0,1,0-2-2A2,2,0,0,0,323.84,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,173a2,2,0,1,0-2-2A2,2,0,0,0,331.89,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,173a2,2,0,1,0-2-2A2,2,0,0,0,339.94,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,173a2,2,0,1,0-2-2A2,2,0,0,0,348,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,173a2,2,0,1,0-2-2A2,2,0,0,0,356,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,173a2,2,0,1,0-2-2A2,2,0,0,0,364.08,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,173a2,2,0,1,0-2-2A2,2,0,0,0,372.12,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,173a2,2,0,1,0-2-2A2,2,0,0,0,380.17,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,173a2,2,0,1,0-2-2A2,2,0,0,0,388.21,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,173a2,2,0,1,0-2-2A2,2,0,0,0,396.26,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,173a2,2,0,1,0-2-2A2,2,0,0,0,404.31,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,173a2,2,0,1,0-2-2A2,2,0,0,0,412.35,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,181a2,2,0,1,0-2-2A2,2,0,0,0,26.13,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,181a2,2,0,1,0-2-2A2,2,0,0,0,34.18,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,181a2,2,0,1,0-2-2A2,2,0,0,0,42.22,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,181a2,2,0,1,0-2-2A2,2,0,0,0,50.27,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.5,181a2,2,0,1,0-2-2A2,2,0,0,0,90.5,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.55,181a2,2,0,1,0-2-2A2,2,0,0,0,98.55,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,181a2,2,0,1,0-2-2A2,2,0,0,0,106.59,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,181a2,2,0,1,0-2-2A2,2,0,0,0,114.64,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,181a2,2,0,1,0-2-2A2,2,0,0,0,122.69,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,181a2,2,0,1,0-2-2A2,2,0,0,0,130.73,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,181a2,2,0,1,0-2-2A2,2,0,0,0,138.78,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,181a2,2,0,1,0-2-2A2,2,0,0,0,146.83,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,181a2,2,0,1,0-2-2A2,2,0,0,0,154.87,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,181a2,2,0,1,0-2-2A2,2,0,0,0,162.92,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,181a2,2,0,1,0-2-2A2,2,0,0,0,171,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,181a2,2,0,1,0-2-2A2,2,0,0,0,179,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,181a2,2,0,1,0-2-2A2,2,0,0,0,187.06,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,181a2,2,0,1,0-2-2A2,2,0,0,0,195.1,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,181a2,2,0,1,0-2-2A2,2,0,0,0,203.15,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,181a2,2,0,1,0-2-2A2,2,0,0,0,211.2,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,181a2,2,0,1,0-2-2A2,2,0,0,0,219.24,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,181a2,2,0,1,0-2-2A2,2,0,0,0,227.29,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,181a2,2,0,1,0-2-2A2,2,0,0,0,235.33,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,181a2,2,0,1,0-2-2A2,2,0,0,0,243.38,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.47,181a2,2,0,1,0-2-2A2,2,0,0,0,259.47,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,181a2,2,0,1,0-2-2A2,2,0,0,0,267.52,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,181a2,2,0,1,0-2-2A2,2,0,0,0,275.57,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,181a2,2,0,1,0-2-2A2,2,0,0,0,283.61,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,181a2,2,0,1,0-2-2A2,2,0,0,0,291.66,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,181a2,2,0,1,0-2-2A2,2,0,0,0,299.7,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,181a2,2,0,1,0-2-2A2,2,0,0,0,307.75,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,181a2,2,0,1,0-2-2A2,2,0,0,0,315.8,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,181a2,2,0,1,0-2-2A2,2,0,0,0,323.84,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,181a2,2,0,1,0-2-2A2,2,0,0,0,331.89,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.94,181a2,2,0,1,0-2-2A2,2,0,0,0,339.94,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,181a2,2,0,1,0-2-2A2,2,0,0,0,348,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,181a2,2,0,1,0-2-2A2,2,0,0,0,356,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,181a2,2,0,1,0-2-2A2,2,0,0,0,364.08,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,181a2,2,0,1,0-2-2A2,2,0,0,0,372.12,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,181a2,2,0,1,0-2-2A2,2,0,0,0,380.17,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,181a2,2,0,1,0-2-2A2,2,0,0,0,388.21,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,181a2,2,0,1,0-2-2A2,2,0,0,0,396.26,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,181a2,2,0,1,0-2-2A2,2,0,0,0,404.31,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,181a2,2,0,1,0-2-2A2,2,0,0,0,412.35,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,189.05a2,2,0,1,0-2-2A2,2,0,0,0,2,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,189.05a2,2,0,1,0-2-2A2,2,0,0,0,10,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.08,189.05a2,2,0,1,0-2-2A2,2,0,0,0,18.08,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,189.05a2,2,0,1,0-2-2A2,2,0,0,0,26.13,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,189.05a2,2,0,1,0-2-2A2,2,0,0,0,34.18,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,189.05a2,2,0,1,0-2-2A2,2,0,0,0,42.22,189.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.27,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.55,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,189.05a2,2,0,1,0-2-2A2,2,0,0,0,106.59,189.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,189.05a2,2,0,1,0-2-2A2,2,0,0,0,130.73,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,189.05a2,2,0,1,0-2-2A2,2,0,0,0,138.78,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,189.05a2,2,0,1,0-2-2A2,2,0,0,0,146.83,189.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,189.05a2,2,0,1,0-2-2A2,2,0,0,0,171,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,189.05a2,2,0,1,0-2-2A2,2,0,0,0,179,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,189.05a2,2,0,1,0-2-2A2,2,0,0,0,187.06,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,189.05a2,2,0,1,0-2-2A2,2,0,0,0,195.1,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,189.05a2,2,0,1,0-2-2A2,2,0,0,0,203.15,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,189.05a2,2,0,1,0-2-2A2,2,0,0,0,211.2,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,189.05a2,2,0,1,0-2-2A2,2,0,0,0,219.24,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,189.05a2,2,0,1,0-2-2A2,2,0,0,0,227.29,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.33,189.05a2,2,0,1,0-2-2A2,2,0,0,0,235.33,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,189.05a2,2,0,1,0-2-2A2,2,0,0,0,267.52,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,189.05a2,2,0,1,0-2-2A2,2,0,0,0,275.57,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,189.05a2,2,0,1,0-2-2A2,2,0,0,0,283.61,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,189.05a2,2,0,1,0-2-2A2,2,0,0,0,291.66,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,189.05a2,2,0,1,0-2-2A2,2,0,0,0,299.7,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,189.05a2,2,0,1,0-2-2A2,2,0,0,0,307.75,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,189.05a2,2,0,1,0-2-2A2,2,0,0,0,315.8,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,189.05a2,2,0,1,0-2-2A2,2,0,0,0,323.84,189.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.89,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 356.03,
    cy: 187.06,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.08,189.05a2,2,0,1,0-2-2A2,2,0,0,0,364.08,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.12,189.05a2,2,0,1,0-2-2A2,2,0,0,0,372.12,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.17,189.05a2,2,0,1,0-2-2A2,2,0,0,0,380.17,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.21,189.05a2,2,0,1,0-2-2A2,2,0,0,0,388.21,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,189.05a2,2,0,1,0-2-2A2,2,0,0,0,396.26,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,189.05a2,2,0,1,0-2-2A2,2,0,0,0,404.31,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,189.05a2,2,0,1,0-2-2A2,2,0,0,0,412.35,189.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,197.09a2,2,0,1,0-2-2A2,2,0,0,0,2,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,197.09a2,2,0,1,0-2-2A2,2,0,0,0,10,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.08,197.09a2,2,0,1,0-2-2A2,2,0,0,0,18.08,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,197.09a2,2,0,1,0-2-2A2,2,0,0,0,26.13,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,197.09a2,2,0,1,0-2-2A2,2,0,0,0,34.18,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,197.09a2,2,0,1,0-2-2A2,2,0,0,0,42.22,197.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.27,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.55,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,197.09a2,2,0,1,0-2-2A2,2,0,0,0,106.59,197.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,197.09a2,2,0,1,0-2-2A2,2,0,0,0,130.73,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,197.09a2,2,0,1,0-2-2A2,2,0,0,0,138.78,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,197.09a2,2,0,1,0-2-2A2,2,0,0,0,146.83,197.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,197.09a2,2,0,1,0-2-2A2,2,0,0,0,171,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,197.09a2,2,0,1,0-2-2A2,2,0,0,0,179,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,197.09a2,2,0,1,0-2-2A2,2,0,0,0,187.06,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,197.09a2,2,0,1,0-2-2A2,2,0,0,0,195.1,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,197.09a2,2,0,1,0-2-2A2,2,0,0,0,203.15,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,197.09a2,2,0,1,0-2-2A2,2,0,0,0,211.2,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,197.09a2,2,0,1,0-2-2A2,2,0,0,0,219.24,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,197.09a2,2,0,1,0-2-2A2,2,0,0,0,227.29,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,197.09a2,2,0,1,0-2-2A2,2,0,0,0,267.52,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,197.09a2,2,0,1,0-2-2A2,2,0,0,0,275.57,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,197.09a2,2,0,1,0-2-2A2,2,0,0,0,283.61,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,197.09a2,2,0,1,0-2-2A2,2,0,0,0,291.66,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,197.09a2,2,0,1,0-2-2A2,2,0,0,0,299.7,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,197.09a2,2,0,1,0-2-2A2,2,0,0,0,307.75,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,197.09a2,2,0,1,0-2-2A2,2,0,0,0,315.8,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,197.09a2,2,0,1,0-2-2A2,2,0,0,0,323.84,197.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.89,
    cy: 195.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.26,197.09a2,2,0,1,0-2-2A2,2,0,0,0,396.26,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.31,197.09a2,2,0,1,0-2-2A2,2,0,0,0,404.31,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.35,197.09a2,2,0,1,0-2-2A2,2,0,0,0,412.35,197.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,205.14a2,2,0,1,0-2-2A2,2,0,0,0,2,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,205.14a2,2,0,1,0-2-2A2,2,0,0,0,10,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.08,205.14a2,2,0,1,0-2-2A2,2,0,0,0,18.08,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,205.14a2,2,0,1,0-2-2A2,2,0,0,0,26.13,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,205.14a2,2,0,1,0-2-2A2,2,0,0,0,34.18,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,205.14a2,2,0,1,0-2-2A2,2,0,0,0,42.22,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.27,205.14a2,2,0,1,0-2-2A2,2,0,0,0,50.27,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.32,205.14a2,2,0,1,0-2-2A2,2,0,0,0,58.32,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,205.14a2,2,0,1,0-2-2A2,2,0,0,0,106.59,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.64,205.14a2,2,0,1,0-2-2A2,2,0,0,0,114.64,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,205.14a2,2,0,1,0-2-2A2,2,0,0,0,122.69,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,205.14a2,2,0,1,0-2-2A2,2,0,0,0,130.73,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,205.14a2,2,0,1,0-2-2A2,2,0,0,0,138.78,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,205.14a2,2,0,1,0-2-2A2,2,0,0,0,146.83,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,205.14a2,2,0,1,0-2-2A2,2,0,0,0,154.87,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,205.14a2,2,0,1,0-2-2A2,2,0,0,0,162.92,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,205.14a2,2,0,1,0-2-2A2,2,0,0,0,171,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,205.14a2,2,0,1,0-2-2A2,2,0,0,0,179,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,205.14a2,2,0,1,0-2-2A2,2,0,0,0,187.06,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,205.14a2,2,0,1,0-2-2A2,2,0,0,0,195.1,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,205.14a2,2,0,1,0-2-2A2,2,0,0,0,203.15,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,205.14a2,2,0,1,0-2-2A2,2,0,0,0,211.2,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,205.14a2,2,0,1,0-2-2A2,2,0,0,0,219.24,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.29,205.14a2,2,0,1,0-2-2A2,2,0,0,0,227.29,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.52,205.14a2,2,0,1,0-2-2A2,2,0,0,0,267.52,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,205.14a2,2,0,1,0-2-2A2,2,0,0,0,275.57,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,205.14a2,2,0,1,0-2-2A2,2,0,0,0,283.61,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,205.14a2,2,0,1,0-2-2A2,2,0,0,0,291.66,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,205.14a2,2,0,1,0-2-2A2,2,0,0,0,299.7,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,205.14a2,2,0,1,0-2-2A2,2,0,0,0,307.75,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,205.14a2,2,0,1,0-2-2A2,2,0,0,0,315.8,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,205.14a2,2,0,1,0-2-2A2,2,0,0,0,323.84,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.89,205.14a2,2,0,1,0-2-2A2,2,0,0,0,331.89,205.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,213.19a2,2,0,1,0-2-2A2,2,0,0,0,2,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,213.19a2,2,0,1,0-2-2A2,2,0,0,0,10,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.08,213.19a2,2,0,1,0-2-2A2,2,0,0,0,18.08,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.13,213.19a2,2,0,1,0-2-2A2,2,0,0,0,26.13,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.18,213.19a2,2,0,1,0-2-2A2,2,0,0,0,34.18,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.22,213.19a2,2,0,1,0-2-2A2,2,0,0,0,42.22,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,213.19a2,2,0,1,0-2-2A2,2,0,0,0,106.59,213.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 211.2,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 211.2,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,213.19a2,2,0,1,0-2-2A2,2,0,0,0,130.73,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,213.19a2,2,0,1,0-2-2A2,2,0,0,0,138.78,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,213.19a2,2,0,1,0-2-2A2,2,0,0,0,146.83,213.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 211.2,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 211.2,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,213.19a2,2,0,1,0-2-2A2,2,0,0,0,171,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,213.19a2,2,0,1,0-2-2A2,2,0,0,0,179,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,213.19a2,2,0,1,0-2-2A2,2,0,0,0,187.06,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,213.19a2,2,0,1,0-2-2A2,2,0,0,0,195.1,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,213.19a2,2,0,1,0-2-2A2,2,0,0,0,203.15,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,213.19a2,2,0,1,0-2-2A2,2,0,0,0,211.2,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,213.19a2,2,0,1,0-2-2A2,2,0,0,0,219.24,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,213.19a2,2,0,1,0-2-2A2,2,0,0,0,275.57,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,213.19a2,2,0,1,0-2-2A2,2,0,0,0,283.61,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.66,213.19a2,2,0,1,0-2-2A2,2,0,0,0,291.66,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,213.19a2,2,0,1,0-2-2A2,2,0,0,0,299.7,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,213.19a2,2,0,1,0-2-2A2,2,0,0,0,307.75,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,213.19a2,2,0,1,0-2-2A2,2,0,0,0,315.8,213.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,213.19a2,2,0,1,0-2-2A2,2,0,0,0,323.84,213.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 114.64,
    cy: 219.24,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 122.69,
    cy: 219.24,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,221.23a2,2,0,1,0-2-2A2,2,0,0,0,130.73,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,221.23a2,2,0,1,0-2-2A2,2,0,0,0,138.78,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,221.23a2,2,0,1,0-2-2A2,2,0,0,0,146.83,221.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.87,
    cy: 219.24,
    r: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 162.92,
    cy: 219.24,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,221.23a2,2,0,1,0-2-2A2,2,0,0,0,171,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179,221.23a2,2,0,1,0-2-2A2,2,0,0,0,179,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.06,221.23a2,2,0,1,0-2-2A2,2,0,0,0,187.06,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.1,221.23a2,2,0,1,0-2-2A2,2,0,0,0,195.1,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.15,221.23a2,2,0,1,0-2-2A2,2,0,0,0,203.15,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,221.23a2,2,0,1,0-2-2A2,2,0,0,0,211.2,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,221.23a2,2,0,1,0-2-2A2,2,0,0,0,219.24,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,221.23a2,2,0,1,0-2-2A2,2,0,0,0,299.7,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,221.23a2,2,0,1,0-2-2A2,2,0,0,0,307.75,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,221.23a2,2,0,1,0-2-2A2,2,0,0,0,315.8,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.84,221.23a2,2,0,1,0-2-2A2,2,0,0,0,323.84,221.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,229.28a2,2,0,1,0-2-2A2,2,0,0,0,122.69,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,229.28a2,2,0,1,0-2-2A2,2,0,0,0,130.73,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,229.28a2,2,0,1,0-2-2A2,2,0,0,0,138.78,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,229.28a2,2,0,1,0-2-2A2,2,0,0,0,146.83,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,229.28a2,2,0,1,0-2-2A2,2,0,0,0,154.87,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.92,229.28a2,2,0,1,0-2-2A2,2,0,0,0,162.92,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,229.28a2,2,0,1,0-2-2A2,2,0,0,0,171,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.2,229.28a2,2,0,1,0-2-2A2,2,0,0,0,211.2,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.7,229.28a2,2,0,1,0-2-2A2,2,0,0,0,299.7,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,229.28a2,2,0,1,0-2-2A2,2,0,0,0,307.75,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.8,229.28a2,2,0,1,0-2-2A2,2,0,0,0,315.8,229.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.69,237.33a2,2,0,1,0-2-2A2,2,0,0,0,122.69,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.73,237.33a2,2,0,1,0-2-2A2,2,0,0,0,130.73,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,237.33a2,2,0,1,0-2-2A2,2,0,0,0,138.78,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,237.33a2,2,0,1,0-2-2A2,2,0,0,0,146.83,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,237.33a2,2,0,1,0-2-2A2,2,0,0,0,154.87,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.75,237.33a2,2,0,1,0-2-2A2,2,0,0,0,307.75,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,245.37a2,2,0,1,0-2-2A2,2,0,0,0,138.78,245.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.83,245.37a2,2,0,1,0-2-2A2,2,0,0,0,146.83,245.37Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 110.77,
    cy: 110.37,
    r: 8.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.71,145.19a3,3,0,0,1-3-2,3.48,3.48,0,0,1-.27-1.25v-.66a26.24,26.24,0,0,1,1.13-6.2c-2.25.06-4,.13-5.28.2-.38.69-.72,1.35-1,2l-1,1.92a15.83,15.83,0,0,1-3.52,5.06,4.19,4.19,0,0,1-2.63,1,2.08,2.08,0,0,1-1.71-.75,1.42,1.42,0,0,1-.27-.63.51.51,0,0,1,.24-.57,6.62,6.62,0,0,0,2.84-2,21.57,21.57,0,0,0,1.94-3l1.52-2.71-.49.07a2.79,2.79,0,0,1-.47.05.84.84,0,0,1-.51-.13.55.55,0,0,1-.24-.46,1.38,1.38,0,0,1,.66-1.09,5.67,5.67,0,0,1,2-1l.57-.14A60.88,60.88,0,0,1,56.06,127a36,36,0,0,1,2.49-2.83,16.47,16.47,0,0,1,2.38-2,9.66,9.66,0,0,1,5.46-1.9,1.6,1.6,0,0,1,1.27.41A1.36,1.36,0,0,1,68,122c-.11.39-.3,1-.56,1.69-1.57,4.25-2.5,6.85-2.93,8.07H65c1.59,0,2,.2,2.1.5a1.93,1.93,0,0,1,0,.49,1.75,1.75,0,0,1-.21.77,1.81,1.81,0,0,1-.67.74,5.54,5.54,0,0,1-2.72.69,33.82,33.82,0,0,0-1.15,4.85,3.51,3.51,0,0,0,.07,1.76c.15.31.32.35.46.35a2.3,2.3,0,0,0,.65-.07l.46-.18.41-.19a.77.77,0,0,1,.43-.12.55.55,0,0,1,.49.35,1.45,1.45,0,0,1,.14.67,1.87,1.87,0,0,1-.33.94,3.51,3.51,0,0,1-.81.92A4.13,4.13,0,0,1,61.71,145.19Zm2.29-22c-1.91.7-3.84,2.49-5.73,5.33-.45.67-.88,1.35-1.31,2.05l-1,1.64c1.59-.2,3.1-.32,4.49-.36.27-.84.57-1.68.88-2.49l1-2.5c.34-.8.67-1.55,1-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.39,120.53a1.39,1.39,0,0,1,1.08.33,1.07,1.07,0,0,1,.29,1.09c-.11.4-.3,1-.56,1.68-1.66,4.53-2.68,7.34-3,8.42H65c1.17,0,1.79.11,1.88.34a1.77,1.77,0,0,1,0,.4,1.56,1.56,0,0,1-.18.66,1.63,1.63,0,0,1-.59.64,5.61,5.61,0,0,1-2.77.66,35.31,35.31,0,0,0-1.21,5.06,4,4,0,0,0,.09,1.9.74.74,0,0,0,.69.49,2.81,2.81,0,0,0,.72-.08,3.46,3.46,0,0,0,.5-.2l.41-.19a.62.62,0,0,1,.32-.09q.16,0,.27.21a1.27,1.27,0,0,1,.11.56,1.66,1.66,0,0,1-.29.81,3,3,0,0,1-.76.85,3.79,3.79,0,0,1-2.46.88,2.74,2.74,0,0,1-2.81-1.87,3.52,3.52,0,0,1-.25-1.17v-.66a26.84,26.84,0,0,1,1.21-6.46c-2.51.07-4.43.14-5.76.22-.41.74-.78,1.44-1.11,2.11L52,139a15.43,15.43,0,0,1-3.44,5,3.89,3.89,0,0,1-2.48.94,1.79,1.79,0,0,1-1.51-.66,1.08,1.08,0,0,1-.22-.5c0-.17,0-.27.11-.32a6.74,6.74,0,0,0,2.91-2.05,21.24,21.24,0,0,0,2-3l1.76-3.15-1,.14a2.69,2.69,0,0,1-.44.05c-.33,0-.5-.12-.5-.34a1.15,1.15,0,0,1,.56-.89,5.61,5.61,0,0,1,1.92-1l.67-.16a64.08,64.08,0,0,1,3.91-5.91,35.26,35.26,0,0,1,2.46-2.8,18.09,18.09,0,0,1,2.35-2,9.42,9.42,0,0,1,5.32-1.85m-1.92,2.28q-3.24.84-6.41,5.59c-.45.67-.88,1.36-1.31,2.06l-1.22,2.08a50.12,50.12,0,0,1,5.15-.42c.29-.9.6-1.78.94-2.65l1-2.5c.34-.79.66-1.54,1-2.25l.9-1.91M66.39,120a9.88,9.88,0,0,0-5.6,1.94,18.3,18.3,0,0,0-2.42,2c-.75.76-1.59,1.72-2.5,2.85A60.58,60.58,0,0,0,52,132.64l-.46.11a6.07,6.07,0,0,0-2.11,1.06,1.63,1.63,0,0,0-.76,1.29c0,.39.26.84,1,.84a3,3,0,0,0,.49-.05l-1.27,2.27A20.26,20.26,0,0,1,47,141.1,6.24,6.24,0,0,1,44.3,143h0l0,0a.78.78,0,0,0-.36.82,1.65,1.65,0,0,0,.31.73,2.29,2.29,0,0,0,1.92.87,4.39,4.39,0,0,0,2.79-1.05,15.6,15.6,0,0,0,3.58-5.14l1-1.92c.29-.58.61-1.2,1-1.85,1.18-.06,2.78-.12,4.79-.18a25.32,25.32,0,0,0-1.05,5.94v.66a3.77,3.77,0,0,0,.29,1.34,3.22,3.22,0,0,0,3.27,2.2,4.32,4.32,0,0,0,2.78-1,3.68,3.68,0,0,0,.87-1,2.12,2.12,0,0,0,.36-1.07,1.62,1.62,0,0,0-.17-.79.8.8,0,0,0-.71-.48,1.08,1.08,0,0,0-.55.15l-.39.18a3.5,3.5,0,0,1-.43.17,2.12,2.12,0,0,1-.58.06s-.13,0-.24-.21a3.53,3.53,0,0,1,0-1.62,32.38,32.38,0,0,1,1.09-4.65,5.5,5.5,0,0,0,2.68-.71,2.22,2.22,0,0,0,.75-.84,2.1,2.1,0,0,0,.23-.88,2.28,2.28,0,0,0,0-.54c-.2-.53-.81-.7-2.36-.7h-.08c.46-1.34,1.37-3.84,2.8-7.74.26-.73.45-1.31.57-1.7a1.58,1.58,0,0,0-.4-1.58,1.81,1.81,0,0,0-1.45-.49Zm-9.91,11.89.7-1.2c.42-.7.86-1.38,1.3-2a13.75,13.75,0,0,1,5-5l-.39.81c-.32.72-.65,1.47-1,2.27l-1,2.5c-.29.78-.57,1.56-.83,2.35-1.2,0-2.49.14-3.84.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.65,145.19a3,3,0,0,1-3-1.82,3.17,3.17,0,0,1-.25-1.32,6.12,6.12,0,0,1,.23-1.61,13.41,13.41,0,0,1,.57-1.77c.23-.6.48-1.2.77-1.82l.79-1.81c1.34-3.11,1.26-3.82,1.16-4a1.74,1.74,0,0,0-.63-.51.64.64,0,0,1-.3-.6,1,1,0,0,1,.29-.69,2.35,2.35,0,0,1,.67-.5,3.84,3.84,0,0,1,1.63-.38,3.51,3.51,0,0,1,1.26.18,2.45,2.45,0,0,1,.73.46,2,2,0,0,1,.58,1.43,6.07,6.07,0,0,1-.29,1.73c-.19.61-.42,1.24-.71,2s-.59,1.37-.93,2.08l-.92,2a10.32,10.32,0,0,0-1,2.89c0,1.05.41,1.19.77,1.19,1.64,0,3.22-1,4.68-3a11.49,11.49,0,0,0,1.86-3.82,6.81,6.81,0,0,0,.26-1.75c0-.52,0-1-.05-1.34a6.9,6.9,0,0,0-.17-.92,3,3,0,0,0-.64-1.2c-.18-.23-.38-.69.32-1.3a3.18,3.18,0,0,1,2.11-.64,2,2,0,0,1,1.57.82,4,4,0,0,1,.81,2.66,11.11,11.11,0,0,1-.5,3.28A14.85,14.85,0,0,1,81,138.21a16.19,16.19,0,0,1-2,2.73,15.35,15.35,0,0,1-2.51,2.21A10.16,10.16,0,0,1,70.65,145.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.47,128.64a1.73,1.73,0,0,1,1.38.73,3.73,3.73,0,0,1,.75,2.5,10.85,10.85,0,0,1-.49,3.2,14.12,14.12,0,0,1-1.32,3,16.27,16.27,0,0,1-2,2.69,15.19,15.19,0,0,1-2.47,2.17,9.87,9.87,0,0,1-5.68,2,2.76,2.76,0,0,1-2.78-1.67,3.05,3.05,0,0,1-.23-1.22,6.08,6.08,0,0,1,.22-1.55,14,14,0,0,1,.56-1.74c.23-.59.48-1.19.76-1.81l.8-1.81q1.55-3.57,1.14-4.21a2.06,2.06,0,0,0-.72-.59.4.4,0,0,1-.17-.38.78.78,0,0,1,.22-.53,2.15,2.15,0,0,1,.6-.43,3.49,3.49,0,0,1,1.52-.36,3.19,3.19,0,0,1,1.16.16,2.2,2.2,0,0,1,.66.42,1.67,1.67,0,0,1,.5,1.24,5.7,5.7,0,0,1-.28,1.66c-.19.61-.42,1.25-.7,1.93s-.59,1.37-.92,2.07l-.92,2a9.81,9.81,0,0,0-1,3c0,1,.33,1.44,1,1.44,1.74,0,3.36-1,4.88-3.09a11.78,11.78,0,0,0,1.9-3.9,7,7,0,0,0,.27-1.82,12.78,12.78,0,0,0-.06-1.36,4.3,4.3,0,0,0-.18-1,3.08,3.08,0,0,0-.68-1.29c-.22-.27-.12-.59.3-.95a2.88,2.88,0,0,1,1.94-.58m0-.5a3.46,3.46,0,0,0-2.27.69c-.89.79-.55,1.42-.36,1.65a2.71,2.71,0,0,1,.59,1.11,5.22,5.22,0,0,1,.17.89c0,.35.05.8.05,1.31a6.46,6.46,0,0,1-.25,1.69,11.25,11.25,0,0,1-1.82,3.73c-1.41,1.92-2.92,2.89-4.48,2.89-.18,0-.51,0-.51-.94a9.21,9.21,0,0,1,.94-2.79l.91-2c.32-.67.62-1.35.93-2.09s.53-1.36.72-2a6.26,6.26,0,0,0,.3-1.8,2.17,2.17,0,0,0-.64-1.59,2.67,2.67,0,0,0-.83-.53,3.52,3.52,0,0,0-1.35-.2,4,4,0,0,0-1.73.41,2.28,2.28,0,0,0-.75.55,1.23,1.23,0,0,0-.36.86.88.88,0,0,0,.4.8,1.49,1.49,0,0,1,.56.44c0,.08.15.7-1.17,3.74l-.8,1.81c-.28.62-.54,1.24-.77,1.83a17,17,0,0,0-.58,1.8,7,7,0,0,0-.23,1.67,3.41,3.41,0,0,0,.28,1.43,3.26,3.26,0,0,0,3.23,2,10.38,10.38,0,0,0,6-2.09,15.81,15.81,0,0,0,2.56-2.24,16.34,16.34,0,0,0,2-2.78,14.57,14.57,0,0,0,1.37-3.11,11.2,11.2,0,0,0,.51-3.35,4.24,4.24,0,0,0-.87-2.82,2.22,2.22,0,0,0-1.76-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.42,145.19a5.27,5.27,0,0,1-3.85-1.45A5.69,5.69,0,0,1,84,139.31a10.58,10.58,0,0,1,.46-2.66,12.31,12.31,0,0,1,1.07-2.45A14.26,14.26,0,0,1,87.12,132a12.59,12.59,0,0,1,1.95-1.85,7.77,7.77,0,0,1,4.66-1.72,3.72,3.72,0,0,1,3.79,2.35,4.71,4.71,0,0,1,.31,1.87,5.11,5.11,0,0,1-.41,2,5.74,5.74,0,0,1-1.08,1.65,8.25,8.25,0,0,1-1.63,1.32,11.91,11.91,0,0,1-2,1,15.19,15.19,0,0,1-4.63.82c0,.1,0,.23,0,.42a3.78,3.78,0,0,0,.09.91,2.52,2.52,0,0,0,.34.88,1.54,1.54,0,0,0,1.41.82,6.46,6.46,0,0,0,3.39-1,4.88,4.88,0,0,0,1-.71,1.23,1.23,0,0,1,.84-.45.82.82,0,0,1,.7.45,1.59,1.59,0,0,1,.25.89,2.48,2.48,0,0,1-.52,1.58C94.1,144.5,92.07,145.19,89.42,145.19Zm4-14.23c-1,0-2,.72-3,2.14a16.58,16.58,0,0,0-1.91,4.15,7.34,7.34,0,0,0,4-1.95,4.44,4.44,0,0,0,1.68-3C94.21,131,93.61,131,93.39,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.73,128.64a3.47,3.47,0,0,1,3.56,2.2,4.57,4.57,0,0,1,.29,1.77,4.82,4.82,0,0,1-.39,1.88,5.45,5.45,0,0,1-1,1.58,7.72,7.72,0,0,1-1.58,1.27,10.44,10.44,0,0,1-2,.95,14.73,14.73,0,0,1-4.74.81,3.1,3.1,0,0,0-.08.66,4.27,4.27,0,0,0,.09,1,2.92,2.92,0,0,0,.38,1,1.77,1.77,0,0,0,1.62.94,6.62,6.62,0,0,0,3.53-1.06,5.54,5.54,0,0,0,1-.74,1,1,0,0,1,.66-.38.59.59,0,0,1,.49.33,1.4,1.4,0,0,1,.21.76,2.22,2.22,0,0,1-.47,1.43q-2,2-5.85,2a5,5,0,0,1-3.68-1.38,5.43,5.43,0,0,1-1.46-4.24,10,10,0,0,1,.45-2.59,13.09,13.09,0,0,1,1-2.41,14.28,14.28,0,0,1,1.54-2.2,12.49,12.49,0,0,1,1.91-1.81,7.45,7.45,0,0,1,4.51-1.67m-5.55,8.9a7.57,7.57,0,0,0,4.52-2,4.67,4.67,0,0,0,1.76-3.23c0-1-.36-1.55-1.07-1.55q-1.65,0-3.15,2.25a16.78,16.78,0,0,0-2.06,4.58m5.55-9.4a8,8,0,0,0-4.81,1.77,12.23,12.23,0,0,0-2,1.89,14.32,14.32,0,0,0-1.59,2.28,13.15,13.15,0,0,0-1.09,2.5,10.54,10.54,0,0,0-.47,2.72,5.94,5.94,0,0,0,1.61,4.62,5.51,5.51,0,0,0,4,1.52c2.72,0,4.81-.71,6.21-2.11l0,0,0,0a2.78,2.78,0,0,0,.57-1.74,2,2,0,0,0-.28-1A1.06,1.06,0,0,0,95,140a1.5,1.5,0,0,0-1,.52,4.21,4.21,0,0,1-.89.67,6.14,6.14,0,0,1-3.27,1,1.29,1.29,0,0,1-1.19-.69,2.42,2.42,0,0,1-.31-.8,3.45,3.45,0,0,1-.09-.86c0-.07,0-.13,0-.19a15,15,0,0,0,4.48-.83,11.09,11.09,0,0,0,2.08-1,8.12,8.12,0,0,0,1.68-1.36,5.89,5.89,0,0,0,1.13-1.72,5.43,5.43,0,0,0,.43-2.07,5,5,0,0,0-.33-2,3.94,3.94,0,0,0-4-2.5Zm-4.84,8.79a16.71,16.71,0,0,1,1.76-3.7c.9-1.34,1.83-2,2.74-2,.2,0,.57,0,.57,1a4.24,4.24,0,0,1-1.61,2.86,7.07,7.07,0,0,1-3.46,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.14,145.19a4.39,4.39,0,0,1-1.4-.19,2.65,2.65,0,0,1-1-.6,3.19,3.19,0,0,1-1-2.49,12.52,12.52,0,0,1,1.16-4.62c.58-1.3,1-2.11,1.18-2.56l.52-1.1a3.65,3.65,0,0,0,.46-1.47c0-.1,0-.32-.61-.32-.14,0-.47.11-1.19.85s-1.1,1.17-1.53,1.68L106.38,136l-2.55,3.25c-.57,1.09-1,2-1.39,2.8l-.84,1.82a4.56,4.56,0,0,1-.61,1,1.06,1.06,0,0,1-.84.36,2.51,2.51,0,0,1-.89-.17,2.73,2.73,0,0,1-.73-.42,1.69,1.69,0,0,1-.68-1.29,2.54,2.54,0,0,1,.37-1l.59-1.25c.19-.38.4-.85.65-1.43l.87-2.14c1.21-3,1.82-5,1.82-5.84a1,1,0,0,0-.36-.86l-.31-.22a.65.65,0,0,1-.26-.58,1,1,0,0,1,.27-.69,2.21,2.21,0,0,1,.62-.49,3.34,3.34,0,0,1,1.53-.39,3.52,3.52,0,0,1,1.2.17,2.25,2.25,0,0,1,.74.48,1.82,1.82,0,0,1,.65,1.32,5.49,5.49,0,0,1-.16,1.25c-.1.4-.23.82-.38,1.24l-.36.94c.41-.57.71-1,.9-1.21l1.1-1.31a10.64,10.64,0,0,1,1.94-1.91,4.59,4.59,0,0,1,2.32-1,4.09,4.09,0,0,1,1.43.22,3,3,0,0,1,1,.63,2.87,2.87,0,0,1,.94,2.2,7.12,7.12,0,0,1-.58,2.68c-.38.89-.71,1.63-1,2.19s-.54,1.11-.79,1.68a10.71,10.71,0,0,0-1.14,3.69c0,.07,0,.28.59.28a2.33,2.33,0,0,0,1.08-.26,1.89,1.89,0,0,1,.81-.3.53.53,0,0,1,.57.57A3,3,0,0,1,113,144.5,3.38,3.38,0,0,1,111.14,145.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.59,128.64a4,4,0,0,1,1.34.2,3,3,0,0,1,.95.58,2.64,2.64,0,0,1,.86,2,6.75,6.75,0,0,1-.56,2.58c-.38.89-.7,1.62-1,2.18s-.53,1.12-.78,1.69a10.79,10.79,0,0,0-1.17,3.79c0,.35.28.53.84.53a2.61,2.61,0,0,0,1.19-.28,2.08,2.08,0,0,1,.7-.28.29.29,0,0,1,.32.32,2.74,2.74,0,0,1-1.42,2.33,3.22,3.22,0,0,1-1.74.64,4.46,4.46,0,0,1-1.32-.17,2.58,2.58,0,0,1-.93-.55,3,3,0,0,1-.92-2.31,12.2,12.2,0,0,1,1.14-4.52c.55-1.24.94-2.09,1.17-2.54l.53-1.11a4,4,0,0,0,.48-1.58c0-.38-.28-.57-.86-.57-.32,0-.77.31-1.37.92s-1.1,1.19-1.54,1.7l-1.33,1.59-2.56,3.26q-.9,1.71-1.41,2.85l-.85,1.81a4.08,4.08,0,0,1-.56.94.83.83,0,0,1-.66.28,2.18,2.18,0,0,1-.8-.15,2.65,2.65,0,0,1-.66-.38,1.46,1.46,0,0,1-.59-1.1,2.65,2.65,0,0,1,.34-.91l.59-1.27c.19-.37.41-.85.66-1.43l.87-2.14q1.84-4.6,1.84-5.94a1.21,1.21,0,0,0-.46-1.06l-.32-.22a.44.44,0,0,1-.15-.38.81.81,0,0,1,.21-.53,1.88,1.88,0,0,1,.55-.43,3.08,3.08,0,0,1,1.41-.36,2.9,2.9,0,0,1,1.1.16,1.87,1.87,0,0,1,.66.42,1.59,1.59,0,0,1,.58,1.14,4.91,4.91,0,0,1-.15,1.19,12,12,0,0,1-.38,1.21c-.15.41-.31.82-.47,1.21s-.32.74-.46,1l-.31.67c-.06.12-.09.18-.08.18l0,0q1.72-2.4,2.28-3.09l1.09-1.31a10.76,10.76,0,0,1,1.89-1.86,4.41,4.41,0,0,1,2.18-.93m0-.5a4.76,4.76,0,0,0-2.46,1,10.73,10.73,0,0,0-2,2l-1,1.2c.07-.22.13-.43.18-.64a5.48,5.48,0,0,0,.17-1.31,2.08,2.08,0,0,0-.74-1.51,2.46,2.46,0,0,0-.81-.52,3.48,3.48,0,0,0-1.29-.19,3.65,3.65,0,0,0-1.64.41,2.5,2.5,0,0,0-.7.56,1.28,1.28,0,0,0-.33.85.9.9,0,0,0,.37.79l.31.22a.72.72,0,0,1,.25.65c0,.56-.31,2-1.8,5.75l-.87,2.14c-.24.56-.46,1-.64,1.4l-.6,1.27a2.73,2.73,0,0,0-.39,1.13,1.92,1.92,0,0,0,.77,1.48,2.74,2.74,0,0,0,.8.46,2.55,2.55,0,0,0,1,.19,1.34,1.34,0,0,0,1-.45,4.78,4.78,0,0,0,.64-1.05l.85-1.82c.34-.74.8-1.68,1.39-2.79l2.53-3.22,1.31-1.58c.42-.49.92-1,1.52-1.67s1-.77,1-.77a.69.69,0,0,1,.37.06,3.56,3.56,0,0,1-.44,1.37l-.53,1.11c-.22.44-.6,1.25-1.18,2.55a12.93,12.93,0,0,0-1.18,4.73,3.44,3.44,0,0,0,1.09,2.68,3.14,3.14,0,0,0,1.1.65,4.86,4.86,0,0,0,1.48.2,3.68,3.68,0,0,0,2-.73A3.21,3.21,0,0,0,114.8,142a.78.78,0,0,0-.82-.82,2.1,2.1,0,0,0-.93.33,2.06,2.06,0,0,1-1,.23.69.69,0,0,1-.37-.06,11.58,11.58,0,0,1,1.15-3.56c.26-.58.52-1.14.78-1.67s.6-1.29,1-2.21a7.14,7.14,0,0,0,.6-2.77,3.12,3.12,0,0,0-1-2.39,3.54,3.54,0,0,0-1.12-.68,4.52,4.52,0,0,0-1.51-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.29,145.19a5.45,5.45,0,0,1-4.11-1.53,5.75,5.75,0,0,1-1.38-4.26,10.67,10.67,0,0,1,.44-2.78,12.86,12.86,0,0,1,1.08-2.6,12.52,12.52,0,0,1,1.6-2.26,11.79,11.79,0,0,1,2-1.78,8.44,8.44,0,0,1,4.87-1.59,3.69,3.69,0,0,1,3.7,2.19,4.2,4.2,0,0,1,.33,1.77,5.92,5.92,0,0,1-.32,1.78,6.48,6.48,0,0,1-.73,1.44,2.79,2.79,0,0,1-2.13,1.48,2.24,2.24,0,0,1-1.78-.68,1.51,1.51,0,0,1-.33-1.43.88.88,0,0,1,.38-.51,4.82,4.82,0,0,0,.56-.49,3.44,3.44,0,0,0,1-2.32.65.65,0,0,0-.15-.48,1.08,1.08,0,0,0-.79-.22,3.76,3.76,0,0,0-2.56,1.39,11.59,11.59,0,0,0-2.89,5.36c-.48,1.84-.4,3.2.24,4a1.71,1.71,0,0,0,1.45.68,5.3,5.3,0,0,0,3.25-1.2,4.24,4.24,0,0,0,.77-.75,1,1,0,0,1,.77-.5.76.76,0,0,1,.65.37,1.35,1.35,0,0,1,.22.8,2.94,2.94,0,0,1-.89,2A7.41,7.41,0,0,1,122.29,145.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.83,128.64a3.45,3.45,0,0,1,3.47,2,3.84,3.84,0,0,1,.31,1.66,5.35,5.35,0,0,1-.31,1.7,5.59,5.59,0,0,1-.7,1.38q-.94,1.38-1.92,1.38a2,2,0,0,1-1.59-.6,1.27,1.27,0,0,1-.28-1.2.63.63,0,0,1,.28-.36,4.72,4.72,0,0,0,.6-.53,3.66,3.66,0,0,0,1.06-2.48c0-.64-.38-1-1.19-1a4,4,0,0,0-2.74,1.46,11.82,11.82,0,0,0-2.95,5.48q-.75,2.89.28,4.24a2,2,0,0,0,1.65.78,5.54,5.54,0,0,0,3.4-1.25,4.36,4.36,0,0,0,.81-.79c.21-.27.4-.41.58-.41a.52.52,0,0,1,.44.26,1.12,1.12,0,0,1,.18.66,2.67,2.67,0,0,1-.82,1.81,7.15,7.15,0,0,1-5.1,2,5.19,5.19,0,0,1-3.93-1.45,5.48,5.48,0,0,1-1.31-4.09,10.15,10.15,0,0,1,.43-2.71,12.7,12.7,0,0,1,1.06-2.55,11.81,11.81,0,0,1,1.57-2.21,10.91,10.91,0,0,1,2-1.75,8.2,8.2,0,0,1,4.73-1.54m0-.5a8.74,8.74,0,0,0-5,1.63,11.51,11.51,0,0,0-2.08,1.82,12.75,12.75,0,0,0-1.64,2.31,13.35,13.35,0,0,0-1.1,2.65,10.72,10.72,0,0,0-.45,2.84,5.93,5.93,0,0,0,1.45,4.44,5.65,5.65,0,0,0,4.29,1.61,7.61,7.61,0,0,0,5.44-2.17,3.18,3.18,0,0,0,1-2.17,1.64,1.64,0,0,0-.27-.95,1,1,0,0,0-.85-.47,1.27,1.27,0,0,0-1,.6,4,4,0,0,1-.72.71,5.08,5.08,0,0,1-3.1,1.14,1.46,1.46,0,0,1-1.25-.59c-.59-.76-.65-2-.2-3.81a11.48,11.48,0,0,1,2.82-5.25,3.6,3.6,0,0,1,2.39-1.31.88.88,0,0,1,.61.15c.06.05.08.15.08.3a3.15,3.15,0,0,1-.93,2.15,4.51,4.51,0,0,1-.52.46,1.12,1.12,0,0,0-.47.66,1.72,1.72,0,0,0,.39,1.64,2.46,2.46,0,0,0,2,.77,3,3,0,0,0,2.33-1.59,6.39,6.39,0,0,0,.76-1.5,5.74,5.74,0,0,0,.34-1.85,4.21,4.21,0,0,0-.35-1.88,3.92,3.92,0,0,0-3.93-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.71,145.19a4.65,4.65,0,0,1-1.39-.18,2.76,2.76,0,0,1-1-.59,3.47,3.47,0,0,1-1-2.66,12.13,12.13,0,0,1,1.17-4.53l1.69-3.6a3.65,3.65,0,0,0,.46-1.47c0-.21-.06-.32-.39-.32s-1,.33-2.88,2.53L139.06,136l-2.49,3.25c-.6,1.13-1.06,2.06-1.39,2.8l-.85,1.82a4.71,4.71,0,0,1-.6,1,1.08,1.08,0,0,1-.85.36A2.42,2.42,0,0,1,132,145a2.8,2.8,0,0,1-.74-.42,1.69,1.69,0,0,1-.68-1.29,2.59,2.59,0,0,1,.36-1l.62-1.27a82.29,82.29,0,0,0,5.27-15.17,59.45,59.45,0,0,0,1.26-6.09c.16-1.26.92-1.52,1.52-1.52a2.24,2.24,0,0,1,1.34.39,2,2,0,0,1,1,1.64,11,11,0,0,1-.22,1.76c-.13.64-.29,1.34-.49,2.08s-.42,1.53-.67,2.35c-.69,2.1-1.2,3.62-1.53,4.54-.5,1.36-.9,2.44-1.21,3.25,1.65-2.15,2.61-3.37,3-3.81A13.24,13.24,0,0,1,142,129.3a4,4,0,0,1,2.66-.91,2.75,2.75,0,0,1,2.16.91,2.84,2.84,0,0,1,.77,1.91,6.37,6.37,0,0,1-.22,1.76,13.4,13.4,0,0,1-.55,1.57c-.22.52-.46,1.06-.72,1.61l-.78,1.64a10.32,10.32,0,0,0-1.07,3.57c0,.55.23.6.44.6a2.26,2.26,0,0,0,1.07-.26,1.9,1.9,0,0,1,.82-.3.53.53,0,0,1,.57.57,3,3,0,0,1-1.51,2.53A3.52,3.52,0,0,1,143.71,145.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.61,118.49a2,2,0,0,1,1.19.34,1.74,1.74,0,0,1,.87,1.43,10.66,10.66,0,0,1-.22,1.72c-.12.63-.28,1.32-.48,2.06s-.42,1.53-.67,2.35c-.69,2.09-1.19,3.6-1.53,4.53q-1.53,4.19-1.88,4.91l.6-.77c1.9-2.48,3.06-4,3.51-4.45a13.89,13.89,0,0,1,1.14-1.11,3.69,3.69,0,0,1,2.5-.86,2.52,2.52,0,0,1,2,.83,2.61,2.61,0,0,1,.7,1.73,6.33,6.33,0,0,1-.21,1.7,12.31,12.31,0,0,1-.54,1.54c-.22.52-.46,1.06-.72,1.61l-.78,1.63a10.71,10.71,0,0,0-1.09,3.68c0,.57.23.85.69.85a2.64,2.64,0,0,0,1.19-.28,2.08,2.08,0,0,1,.7-.28.29.29,0,0,1,.32.32,2.76,2.76,0,0,1-1.4,2.33,3.34,3.34,0,0,1-1.76.64,4.46,4.46,0,0,1-1.32-.17,2.42,2.42,0,0,1-.93-.54,3.18,3.18,0,0,1-.92-2.47,11.63,11.63,0,0,1,1.15-4.43l1.69-3.59a4,4,0,0,0,.48-1.58c0-.38-.21-.57-.64-.57s-1.59.87-3.07,2.62l-1.29,1.59-2.5,3.26c-.6,1.14-1.08,2.09-1.42,2.85l-.84,1.81a4.41,4.41,0,0,1-.57.94.81.81,0,0,1-.66.28,2.13,2.13,0,0,1-.79-.15,2.72,2.72,0,0,1-.67-.38,1.46,1.46,0,0,1-.59-1.1,2.78,2.78,0,0,1,.33-.91l.62-1.27a81.82,81.82,0,0,0,5.29-15.22,59.45,59.45,0,0,0,1.27-6.11c.11-.88.54-1.31,1.27-1.31m0-.5c-.57,0-1.57.22-1.77,1.74a57.22,57.22,0,0,1-1.25,6.06,82.5,82.5,0,0,1-5.25,15.12l-.63,1.26a2.87,2.87,0,0,0-.38,1.14,1.92,1.92,0,0,0,.77,1.48,2.67,2.67,0,0,0,.81.46,2.5,2.5,0,0,0,1,.19,1.32,1.32,0,0,0,1-.45,4.86,4.86,0,0,0,.65-1.05l.85-1.82c.32-.73.78-1.64,1.38-2.79l2.47-3.23,1.29-1.58c2-2.32,2.58-2.43,2.68-2.43h.14v.06a3.35,3.35,0,0,1-.43,1.36l-1.69,3.59a12.29,12.29,0,0,0-1.2,4.65,3.66,3.66,0,0,0,1.08,2.84,2.87,2.87,0,0,0,1.12.65,5.15,5.15,0,0,0,1.47.19,3.68,3.68,0,0,0,2-.73,3.2,3.2,0,0,0,1.63-2.74.78.78,0,0,0-.82-.82,2.05,2.05,0,0,0-.93.33,2.06,2.06,0,0,1-1,.23c-.11,0-.19,0-.19-.35a10.12,10.12,0,0,1,1.05-3.48l.77-1.62c.28-.59.52-1.12.73-1.63a11.62,11.62,0,0,0,.56-1.59,6.91,6.91,0,0,0,.23-1.84,3.06,3.06,0,0,0-.83-2.06,3,3,0,0,0-2.35-1,4.18,4.18,0,0,0-2.83,1,13.43,13.43,0,0,0-1.17,1.15c-.32.35-1,1.15-2,2.5.19-.51.4-1.06.62-1.68.34-.94.84-2.42,1.54-4.54.25-.84.48-1.63.67-2.38s.37-1.44.5-2.09a12.74,12.74,0,0,0,.22-1.8,2.2,2.2,0,0,0-1.07-1.85,2.41,2.41,0,0,0-1.49-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155,145.19a5.28,5.28,0,0,1-3.86-1.45,5.76,5.76,0,0,1-1.54-4.43,10.16,10.16,0,0,1,.47-2.66,12.87,12.87,0,0,1,1.06-2.45,15,15,0,0,1,1.57-2.24,12.16,12.16,0,0,1,1.95-1.85,7.75,7.75,0,0,1,4.65-1.72,3.7,3.7,0,0,1,3.79,2.35,4.7,4.7,0,0,1,.32,1.87,5.3,5.3,0,0,1-.41,2,5.77,5.77,0,0,1-1.09,1.65,7.71,7.71,0,0,1-1.63,1.32,11.56,11.56,0,0,1-2,1,15.13,15.13,0,0,1-4.62.82,2.19,2.19,0,0,0,0,.42,3.78,3.78,0,0,0,.09.91,2.34,2.34,0,0,0,.34.88,1.54,1.54,0,0,0,1.41.82,6.49,6.49,0,0,0,3.39-1,5.21,5.21,0,0,0,.95-.71,1.22,1.22,0,0,1,.83-.45.83.83,0,0,1,.71.45,1.68,1.68,0,0,1,.25.89,2.54,2.54,0,0,1-.52,1.58A8.2,8.2,0,0,1,155,145.19ZM159,131c-1,0-2,.72-2.94,2.14a16.24,16.24,0,0,0-1.92,4.15,7.3,7.3,0,0,0,4-1.95,4.45,4.45,0,0,0,1.69-3C159.8,131,159.2,131,159,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.31,128.64a3.46,3.46,0,0,1,3.56,2.2,4.38,4.38,0,0,1,.3,1.77,4.82,4.82,0,0,1-.39,1.88,5.48,5.48,0,0,1-1,1.58,7.46,7.46,0,0,1-1.58,1.27,10.35,10.35,0,0,1-2,.95,14.73,14.73,0,0,1-4.74.81,2.56,2.56,0,0,0-.08.66,4.27,4.27,0,0,0,.09,1,2.91,2.91,0,0,0,.37,1,1.79,1.79,0,0,0,1.63.94,6.59,6.59,0,0,0,3.52-1.06,4.9,4.9,0,0,0,1-.74,1,1,0,0,1,.66-.38.61.61,0,0,1,.5.33,1.39,1.39,0,0,1,.2.76,2.27,2.27,0,0,1-.46,1.43q-2,2-5.85,2a5,5,0,0,1-3.68-1.38,5.44,5.44,0,0,1-1.47-4.24,9.64,9.64,0,0,1,.46-2.59,12.44,12.44,0,0,1,1-2.41,14.28,14.28,0,0,1,1.54-2.2,11.63,11.63,0,0,1,1.91-1.81,7.42,7.42,0,0,1,4.5-1.67m-5.55,8.9a7.52,7.52,0,0,0,4.52-2,4.69,4.69,0,0,0,1.77-3.23c0-1-.36-1.55-1.08-1.55q-1.64,0-3.15,2.25a17.09,17.09,0,0,0-2.06,4.58m5.55-9.4a7.93,7.93,0,0,0-4.8,1.77,12.71,12.71,0,0,0-2,1.89,15,15,0,0,0-1.59,2.28,13.11,13.11,0,0,0-1.08,2.5,11,11,0,0,0-.48,2.72,6,6,0,0,0,1.62,4.62,5.49,5.49,0,0,0,4,1.52c2.71,0,4.8-.71,6.2-2.11l0,0,0,0a2.83,2.83,0,0,0,.56-1.74,1.86,1.86,0,0,0-.28-1,1,1,0,0,0-.92-.57,1.48,1.48,0,0,0-1,.52,4.21,4.21,0,0,1-.89.67,6.19,6.19,0,0,1-3.27,1,1.31,1.31,0,0,1-1.2-.69,2.4,2.4,0,0,1-.31-.81,3.79,3.79,0,0,1-.08-.85,1.15,1.15,0,0,1,0-.19,14.89,14.89,0,0,0,4.47-.83,10.89,10.89,0,0,0,2.09-1,8.4,8.4,0,0,0,1.68-1.36,6.33,6.33,0,0,0,1.13-1.72,5.63,5.63,0,0,0,.43-2.07,5,5,0,0,0-.34-2,3.93,3.93,0,0,0-4-2.5Zm-4.83,8.79a15.86,15.86,0,0,1,1.76-3.7c.9-1.34,1.82-2,2.73-2,.2,0,.58,0,.58,1a4.24,4.24,0,0,1-1.61,2.86,7.16,7.16,0,0,1-3.46,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.17,145.17a5.12,5.12,0,0,1-3.34-1,2.7,2.7,0,0,1-1.06-2.11,2.19,2.19,0,0,1,.24-1,2.74,2.74,0,0,1,.58-.76,2.23,2.23,0,0,1,1.54-.67.8.8,0,0,1,.87.89,2.16,2.16,0,0,0,1,2,1.31,1.31,0,0,0,.68.2,2.27,2.27,0,0,0,.64-.08,1.42,1.42,0,0,0,.47-.25,1.11,1.11,0,0,0,.46-.88,2.2,2.2,0,0,0-.24-1,8,8,0,0,0-.69-1.07l-.89-1.25a8.17,8.17,0,0,1-1.92-4.75,4.58,4.58,0,0,1,1.56-3.35,6.29,6.29,0,0,1,4.49-1.67,5.52,5.52,0,0,1,3.77,1.2,3,3,0,0,1,1.15,2.29,2.65,2.65,0,0,1-1,2.17,2.43,2.43,0,0,1-1.49.57,2.71,2.71,0,0,1-.4,0,1.16,1.16,0,0,1-.74-.49,1,1,0,0,1-.11-.91,2.3,2.3,0,0,0,.12-.74,1.64,1.64,0,0,0-.14-.67,1.55,1.55,0,0,0-.36-.53,1.43,1.43,0,0,0-1-.45,2.86,2.86,0,0,0-.91.12,1.77,1.77,0,0,0-.6.34,1.53,1.53,0,0,0-.52,1.19,2.9,2.9,0,0,0,.26,1.3,8,8,0,0,0,.67,1.15c.27.39.57.79.89,1.19a14.18,14.18,0,0,1,.9,1.3,5.68,5.68,0,0,1,1,2.9,3.94,3.94,0,0,1-.54,2.13,4.93,4.93,0,0,1-1.36,1.45A6.45,6.45,0,0,1,168.17,145.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.52,128.64a5.3,5.3,0,0,1,3.61,1.14,2.71,2.71,0,0,1,1.06,2.1,2.37,2.37,0,0,1-.94,2,2.2,2.2,0,0,1-1.33.52,1.34,1.34,0,0,1-.35,0A.9.9,0,0,1,174,134a.77.77,0,0,1-.08-.7,2.41,2.41,0,0,0,.13-.81,1.93,1.93,0,0,0-.16-.77,1.66,1.66,0,0,0-.42-.61,1.62,1.62,0,0,0-1.15-.52,3.39,3.39,0,0,0-1,.13,2,2,0,0,0-.68.39,1.78,1.78,0,0,0-.61,1.38,3.26,3.26,0,0,0,.28,1.41A9,9,0,0,0,171,135q.42.6.9,1.2a13.94,13.94,0,0,1,.89,1.28,5.5,5.5,0,0,1,1,2.77,3.67,3.67,0,0,1-.5,2,5,5,0,0,1-1.29,1.38,6.23,6.23,0,0,1-3.81,1.26,4.87,4.87,0,0,1-3.18-1,2.47,2.47,0,0,1-1-1.92,1.82,1.82,0,0,1,.22-.9,2,2,0,0,1,.52-.69,2,2,0,0,1,1.37-.61c.42,0,.62.21.62.64a2.41,2.41,0,0,0,1.08,2.26,1.51,1.51,0,0,0,.81.23,2.53,2.53,0,0,0,.72-.09,1.52,1.52,0,0,0,.54-.3,1.32,1.32,0,0,0,.56-1.07,2.47,2.47,0,0,0-.27-1.15,9.62,9.62,0,0,0-.71-1.1l-.89-1.25a7.93,7.93,0,0,1-1.87-4.6,4.31,4.31,0,0,1,1.48-3.16,6,6,0,0,1,4.32-1.61m0-.5a6.48,6.48,0,0,0-4.66,1.74,4.8,4.8,0,0,0-1.64,3.53,8.36,8.36,0,0,0,2,4.9l.89,1.24a9.5,9.5,0,0,1,.67,1,1.94,1.94,0,0,1,.21.91.81.81,0,0,1-.37.68,1.11,1.11,0,0,1-.38.21,1.85,1.85,0,0,1-.57.07,1,1,0,0,1-.55-.16,1.93,1.93,0,0,1-.84-1.83,1,1,0,0,0-1.12-1.14,2.49,2.49,0,0,0-1.71.74,2.76,2.76,0,0,0-.63.83,2.39,2.39,0,0,0-.27,1.13,2.93,2.93,0,0,0,1.15,2.3,5.34,5.34,0,0,0,3.5,1.08,6.78,6.78,0,0,0,4.11-1.36,5.55,5.55,0,0,0,1.42-1.52,4.21,4.21,0,0,0,.57-2.26,5.77,5.77,0,0,0-1.06-3,11.6,11.6,0,0,0-.92-1.33c-.3-.38-.6-.77-.88-1.17a8.54,8.54,0,0,1-.65-1.12,2.84,2.84,0,0,1-.23-1.19,1.3,1.3,0,0,1,.45-1,1.53,1.53,0,0,1,.51-.27,2.57,2.57,0,0,1,.82-.11,1.19,1.19,0,0,1,.81.38,1.37,1.37,0,0,1,.3.44,1.4,1.4,0,0,1,.12.58,2.34,2.34,0,0,1-.1.66,1.25,1.25,0,0,0,.14,1.13,1.36,1.36,0,0,0,.88.59,2.49,2.49,0,0,0,.46.05,2.62,2.62,0,0,0,1.64-.63,2.85,2.85,0,0,0,1.13-2.36,3.22,3.22,0,0,0-1.24-2.48,5.74,5.74,0,0,0-3.93-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.65,141.24a26.84,26.84,0,0,1,1.21-6.46c-2.51.07-4.43.14-5.76.22-.41.74-.78,1.44-1.11,2.11L52,139a15.43,15.43,0,0,1-3.44,5,3.89,3.89,0,0,1-2.48.94,1.79,1.79,0,0,1-1.51-.66,1.08,1.08,0,0,1-.22-.5c0-.17,0-.27.11-.32a6.74,6.74,0,0,0,2.91-2.05,21.24,21.24,0,0,0,2-3l1.76-3.15-1,.14c-.63.12-.94,0-.94-.29a1.15,1.15,0,0,1,.56-.89,5.61,5.61,0,0,1,1.92-1l.67-.16a64.08,64.08,0,0,1,3.91-5.91,35.26,35.26,0,0,1,2.46-2.8,18.09,18.09,0,0,1,2.35-2,9.42,9.42,0,0,1,5.32-1.85,1.39,1.39,0,0,1,1.08.33,1.07,1.07,0,0,1,.29,1.09c-.11.4-.3,1-.56,1.68-1.66,4.53-2.68,7.34-3,8.42H65c1.17,0,1.79.11,1.88.34a1.77,1.77,0,0,1,0,.4,1.56,1.56,0,0,1-.18.66,1.63,1.63,0,0,1-.59.64,5.61,5.61,0,0,1-2.77.66,35.31,35.31,0,0,0-1.21,5.06,4,4,0,0,0,.09,1.9.74.74,0,0,0,.69.49,2.81,2.81,0,0,0,.72-.08,3.46,3.46,0,0,0,.5-.2l.41-.19a.62.62,0,0,1,.32-.09q.16,0,.27.21a1.27,1.27,0,0,1,.11.56,1.66,1.66,0,0,1-.29.81,3,3,0,0,1-.76.85,3.79,3.79,0,0,1-2.46.88,2.74,2.74,0,0,1-2.81-1.87,3.52,3.52,0,0,1-.25-1.17Zm-3.12-8.7a50.12,50.12,0,0,1,5.15-.42c.29-.9.6-1.78.94-2.65l1-2.5c.34-.79.66-1.54,1-2.25l.9-1.91q-3.24.84-6.41,5.59c-.45.67-.88,1.36-1.31,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.87,143.27a3.05,3.05,0,0,1-.23-1.22,6.08,6.08,0,0,1,.22-1.55,14,14,0,0,1,.56-1.74c.23-.59.48-1.19.76-1.81l.8-1.81q1.55-3.57,1.14-4.21a2.06,2.06,0,0,0-.72-.59.4.4,0,0,1-.17-.38.78.78,0,0,1,.22-.53,2.15,2.15,0,0,1,.6-.43,3.49,3.49,0,0,1,1.52-.36,3.19,3.19,0,0,1,1.16.16,2.2,2.2,0,0,1,.66.42,1.67,1.67,0,0,1,.5,1.24,5.7,5.7,0,0,1-.28,1.66c-.19.61-.42,1.25-.7,1.93s-.59,1.37-.92,2.07l-.92,2a9.81,9.81,0,0,0-1,3c0,1,.33,1.44,1,1.44,1.74,0,3.36-1,4.88-3.09a11.78,11.78,0,0,0,1.9-3.9,7,7,0,0,0,.27-1.82,12.78,12.78,0,0,0-.06-1.36,4.3,4.3,0,0,0-.18-1,3.08,3.08,0,0,0-.68-1.29c-.22-.27-.12-.59.3-.95a2.88,2.88,0,0,1,1.94-.58,1.73,1.73,0,0,1,1.38.73,3.73,3.73,0,0,1,.75,2.5,10.85,10.85,0,0,1-.49,3.2,14.12,14.12,0,0,1-1.32,3,16.27,16.27,0,0,1-2,2.69,15.19,15.19,0,0,1-2.47,2.17,9.87,9.87,0,0,1-5.68,2A2.76,2.76,0,0,1,67.87,143.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.28,139.32a10,10,0,0,1,.45-2.59,13.09,13.09,0,0,1,1-2.41,14.28,14.28,0,0,1,1.54-2.2,12.49,12.49,0,0,1,1.91-1.81,7.45,7.45,0,0,1,4.51-1.67,3.47,3.47,0,0,1,3.56,2.2,4.57,4.57,0,0,1,.29,1.77,4.82,4.82,0,0,1-.39,1.88,5.45,5.45,0,0,1-1,1.58,7.72,7.72,0,0,1-1.58,1.27,10.44,10.44,0,0,1-2,.95,14.73,14.73,0,0,1-4.74.81,3.1,3.1,0,0,0-.08.66,4.27,4.27,0,0,0,.09,1,2.92,2.92,0,0,0,.38,1,1.77,1.77,0,0,0,1.62.94,6.62,6.62,0,0,0,3.53-1.06,5.54,5.54,0,0,0,1-.74,1,1,0,0,1,.66-.38.59.59,0,0,1,.49.33,1.4,1.4,0,0,1,.21.76,2.22,2.22,0,0,1-.47,1.43q-2,2-5.85,2a5,5,0,0,1-3.68-1.38A5.43,5.43,0,0,1,84.28,139.32Zm9.11-8.61q-1.65,0-3.15,2.25a16.78,16.78,0,0,0-2.06,4.58,7.57,7.57,0,0,0,4.52-2,4.67,4.67,0,0,0,1.76-3.23C94.46,131.23,94.1,130.71,93.39,130.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.43,131.59c-.32,0-.77.31-1.37.92s-1.1,1.19-1.54,1.7l-1.33,1.59-2.56,3.26q-.9,1.71-1.41,2.85l-.85,1.81a4.08,4.08,0,0,1-.56.94.83.83,0,0,1-.66.28,2.18,2.18,0,0,1-.8-.15,2.65,2.65,0,0,1-.66-.38,1.46,1.46,0,0,1-.59-1.1,2.65,2.65,0,0,1,.34-.91l.59-1.27c.19-.37.41-.85.66-1.43l.87-2.14q1.84-4.6,1.84-5.94a1.21,1.21,0,0,0-.46-1.06l-.32-.22a.44.44,0,0,1-.15-.38.81.81,0,0,1,.21-.53,1.88,1.88,0,0,1,.55-.43,3.08,3.08,0,0,1,1.41-.36,2.9,2.9,0,0,1,1.1.16,1.87,1.87,0,0,1,.66.42,1.59,1.59,0,0,1,.58,1.14,4.91,4.91,0,0,1-.15,1.19,12,12,0,0,1-.38,1.21c-.15.41-.31.82-.47,1.21s-.32.74-.46,1l-.31.67c-.08.17-.1.22-.06.16q1.72-2.4,2.28-3.09l1.09-1.31a10.76,10.76,0,0,1,1.89-1.86,4.41,4.41,0,0,1,2.18-.93,4,4,0,0,1,1.34.2,3,3,0,0,1,.95.58,2.64,2.64,0,0,1,.86,2,6.75,6.75,0,0,1-.56,2.58c-.38.89-.7,1.62-1,2.18s-.53,1.12-.78,1.69a10.79,10.79,0,0,0-1.17,3.79c0,.35.28.53.84.53a2.61,2.61,0,0,0,1.19-.28,2.08,2.08,0,0,1,.7-.28.29.29,0,0,1,.32.32,2.74,2.74,0,0,1-1.42,2.33,3.22,3.22,0,0,1-1.74.64,4.46,4.46,0,0,1-1.32-.17,2.58,2.58,0,0,1-.93-.55,3,3,0,0,1-.92-2.31,12.2,12.2,0,0,1,1.14-4.52c.55-1.24.94-2.09,1.17-2.54l.53-1.11a4,4,0,0,0,.48-1.58C111.29,131.78,111,131.59,110.43,131.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.05,139.4a10.15,10.15,0,0,1,.43-2.71,13,13,0,0,1,1.06-2.55,11.81,11.81,0,0,1,1.57-2.21,10.91,10.91,0,0,1,2-1.75,8.2,8.2,0,0,1,4.73-1.54,3.45,3.45,0,0,1,3.47,2,3.84,3.84,0,0,1,.31,1.66,5.35,5.35,0,0,1-.31,1.7,5.59,5.59,0,0,1-.7,1.38q-.94,1.38-1.92,1.38a2,2,0,0,1-1.59-.6,1.27,1.27,0,0,1-.28-1.2.63.63,0,0,1,.28-.36,4.72,4.72,0,0,0,.6-.53,3.66,3.66,0,0,0,1.06-2.48c0-.64-.38-1-1.19-1a4,4,0,0,0-2.74,1.46,11.82,11.82,0,0,0-2.95,5.48q-.75,2.89.28,4.24a2,2,0,0,0,1.65.78,5.54,5.54,0,0,0,3.4-1.25,4.36,4.36,0,0,0,.81-.79c.21-.27.4-.41.58-.41a.52.52,0,0,1,.44.26,1.12,1.12,0,0,1,.18.66,2.67,2.67,0,0,1-.82,1.81,7.15,7.15,0,0,1-5.1,2,5.19,5.19,0,0,1-3.93-1.45A5.48,5.48,0,0,1,117.05,139.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.23,131.59c-.57,0-1.59.87-3.07,2.62l-1.29,1.59-2.5,3.26c-.6,1.14-1.08,2.09-1.42,2.85l-.84,1.81a4.41,4.41,0,0,1-.57.94.81.81,0,0,1-.66.28,2.13,2.13,0,0,1-.79-.15,2.72,2.72,0,0,1-.67-.38,1.46,1.46,0,0,1-.59-1.1,2.78,2.78,0,0,1,.33-.91l.62-1.27a81.82,81.82,0,0,0,5.29-15.22,59.45,59.45,0,0,0,1.27-6.11c.11-.88.54-1.31,1.27-1.31a2,2,0,0,1,1.19.34,1.74,1.74,0,0,1,.87,1.43,10.66,10.66,0,0,1-.22,1.72c-.12.63-.28,1.32-.48,2.06s-.42,1.53-.67,2.35c-.69,2.09-1.19,3.6-1.53,4.53q-1.53,4.19-1.88,4.91l.6-.77c1.9-2.48,3.06-4,3.51-4.45a13.89,13.89,0,0,1,1.14-1.11,3.69,3.69,0,0,1,2.5-.86,2.52,2.52,0,0,1,2,.83,2.61,2.61,0,0,1,.7,1.73,6.33,6.33,0,0,1-.21,1.7,12.31,12.31,0,0,1-.54,1.54c-.22.52-.46,1.06-.72,1.61l-.78,1.63a10.71,10.71,0,0,0-1.09,3.68c0,.57.23.85.69.85a2.64,2.64,0,0,0,1.19-.28,2.08,2.08,0,0,1,.7-.28.29.29,0,0,1,.32.32,2.76,2.76,0,0,1-1.4,2.33,3.34,3.34,0,0,1-1.76.64,4.46,4.46,0,0,1-1.32-.17,2.42,2.42,0,0,1-.93-.54,3.18,3.18,0,0,1-.92-2.47,11.63,11.63,0,0,1,1.15-4.43l1.69-3.59a4,4,0,0,0,.48-1.58C143.87,131.78,143.66,131.59,143.23,131.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.86,139.32a9.64,9.64,0,0,1,.46-2.59,12.44,12.44,0,0,1,1-2.41,14.28,14.28,0,0,1,1.54-2.2,11.63,11.63,0,0,1,1.91-1.81,7.42,7.42,0,0,1,4.5-1.67,3.46,3.46,0,0,1,3.56,2.2,4.38,4.38,0,0,1,.3,1.77,4.82,4.82,0,0,1-.39,1.88,5.48,5.48,0,0,1-1,1.58,7.46,7.46,0,0,1-1.58,1.27,10.35,10.35,0,0,1-2,.95,14.73,14.73,0,0,1-4.74.81,2.56,2.56,0,0,0-.08.66,4.27,4.27,0,0,0,.09,1,2.91,2.91,0,0,0,.37,1,1.79,1.79,0,0,0,1.63.94,6.59,6.59,0,0,0,3.52-1.06,4.9,4.9,0,0,0,1-.74,1,1,0,0,1,.66-.38.61.61,0,0,1,.5.33,1.39,1.39,0,0,1,.2.76,2.27,2.27,0,0,1-.46,1.43q-2,2-5.85,2a5,5,0,0,1-3.68-1.38A5.44,5.44,0,0,1,149.86,139.32Zm9.11-8.61q-1.64,0-3.15,2.25a17.09,17.09,0,0,0-2.06,4.58,7.52,7.52,0,0,0,4.52-2,4.69,4.69,0,0,0,1.77-3.23C160.05,131.23,159.69,130.71,159,130.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164,142a1.82,1.82,0,0,1,.22-.9,2,2,0,0,1,.52-.69,2,2,0,0,1,1.37-.61c.42,0,.62.21.62.64a2.41,2.41,0,0,0,1.08,2.26,1.51,1.51,0,0,0,.81.23,2.53,2.53,0,0,0,.72-.09,1.44,1.44,0,0,0,.54-.3,1.32,1.32,0,0,0,.56-1.07,2.47,2.47,0,0,0-.27-1.15,9.62,9.62,0,0,0-.71-1.1l-.89-1.25a7.93,7.93,0,0,1-1.87-4.6,4.31,4.31,0,0,1,1.48-3.16,6,6,0,0,1,4.32-1.61,5.3,5.3,0,0,1,3.61,1.14,2.71,2.71,0,0,1,1.06,2.1,2.37,2.37,0,0,1-.94,2,2,2,0,0,1-1.68.48A.9.9,0,0,1,174,134a.77.77,0,0,1-.08-.7,2.41,2.41,0,0,0,.13-.81,1.93,1.93,0,0,0-.16-.77,1.66,1.66,0,0,0-.42-.61,1.62,1.62,0,0,0-1.15-.52,3.39,3.39,0,0,0-1,.13,2,2,0,0,0-.68.39,1.78,1.78,0,0,0-.61,1.38,3.26,3.26,0,0,0,.28,1.41A9,9,0,0,0,171,135q.42.6.9,1.2a13.94,13.94,0,0,1,.89,1.28,5.5,5.5,0,0,1,1,2.77,3.67,3.67,0,0,1-.5,2,5,5,0,0,1-1.29,1.38,6.23,6.23,0,0,1-3.81,1.26,4.87,4.87,0,0,1-3.18-1A2.47,2.47,0,0,1,164,142Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwissMap);
export default __webpack_public_path__ + "static/media/swiss-map.03203ae814b21d39e912be4228bfb5b3.svg";
export { ForwardRef as ReactComponent };